import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { timeNewReg, timeNewBold, timeNewItalic, timeNewBoldItalic, corbenBold, corbenRegular, abrilFatfaceRegular, writingRegTxt, devnagriHindi } from '../util/font'
import kailash from '../util/kailash.png'
import arica from '../util/arica.png'
import amin from '../util/amin.png'
import mukesh1_4 from '../util/mukesh1_4.png'
import sumit5_10 from '../util/sumit5_10.png'
import slogan from '../util/slogan.png'
import { currentSession, formatDateddmmyyyy, formatTodayDate, imageBaseUrl, otherPaymentTypeList, romanNumberList, urlToBase64, utcToIST, formatPayOptionLabel } from "./helper";
import { convertPdfToImages } from "./pdftoimage";
require('dotenv').config()

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.vfs["Times-New-Roman-Regular.ttf"] = timeNewReg;
pdfMake.vfs["Times-New-Roman-Bold.ttf"] = timeNewBold;
pdfMake.vfs["Times-New-Roman-Italics.ttf"] = timeNewItalic;
pdfMake.vfs["Times-New-Roman-Bold-Italics.ttf"] = timeNewBoldItalic;
pdfMake.vfs['Corben-Regular.ttf'] = corbenRegular;
pdfMake.vfs['Corben-Bold.ttf'] = corbenBold;
pdfMake.vfs['AbrilFatface-Regular.ttf'] = abrilFatfaceRegular;
pdfMake.vfs['GreatVibes-Regular.ttf'] = writingRegTxt;
pdfMake.vfs['NotoSansDevanagari-Regular.ttf'] = devnagriHindi;

const principalSign = kailash
const examController1 = mukesh1_4
const examController2 = sumit5_10
const examController3 = arica
const photoBorderColor = '#000000' //"#007bff"

// margin [top, bottom, left, right]


export const romanClassConvert = (selectedClass) => {
  return isNaN(parseInt(selectedClass)) ? selectedClass : `${romanNumberList.find(data => data[parseInt(selectedClass)])[parseInt(selectedClass)]} ${selectedClass.includes(' ') && selectedClass.split(' ')[1] ? selectedClass.split(' ')[1] : ''}`
}

const getGrade = (score) => {
  if (score > 100 || score < 0) return "INVALID SCORE";
  if (score >= 91) {
    return "A1"
  } else if (score >= 81) {
    return "A2"
  } else if (score >= 71) {
    return "B1"
  } else if (score >= 61) {
    return "B2"
  } else if (score >= 51) {
    return "C1"
  } else if (score >= 41) {
    return "C2"
  } else if (score >= 33) {
    return "D"
  } else {
    return "E"
  }
}


export const writeRotatedText = text => {
  var ctx, canvas = document.createElement('canvas');
  // I am using predefined dimensions so either make this part of the arguments or change at will 
  canvas.width = 36;
  canvas.height = 320;
  ctx = canvas.getContext('2d');
  ctx.font = '36pt Arial';
  ctx.save();
  ctx.translate(36, 320);
  ctx.rotate(-0.5 * Math.PI);
  ctx.fillStyle = '#000';
  ctx.fillText(text, 0, 0);
  ctx.restore();
  return canvas.toDataURL();
}
export const writeRotatedText2 = text => {
  var ctx, canvas = document.createElement('canvas');
  // I am using predefined dimensions so either make this part of the arguments or change at will 
  canvas.width = 36;
  canvas.height = 450;
  ctx = canvas.getContext('2d');
  ctx.font = '36pt Arial';
  ctx.save();
  ctx.translate(36, 450);
  ctx.rotate(-0.5 * Math.PI);
  ctx.fillStyle = '#000';
  ctx.fillText(text, 0, 0);
  ctx.restore();
  return canvas.toDataURL();
}

const getBusRouteName = (routeId, routeList) => {
  return routeList.find(data => data.busRouteId === routeId)?.route || ' '
}

export const resultPrepToUkgPdf = (resultList, selectedExamType, selectedExamYear, selectedClass, allStudent) => {
  const examName = selectedExamType === 'HALF YEARLY EXAM' ? 'HALF YEARLY EXAMINATION RESULT' : 'ANNUAL EXAMINATION RESULT'
  const session = selectedExamYear
  pdfMake.fonts = {
    // Default font should still be available
    Roboto: {
      normal: 'Roboto-Regular.ttf',
      bold: 'Roboto-Medium.ttf',
      italics: 'Roboto-Italic.ttf',
      bolditalics: 'Roboto-Italic.ttf'
    },
    // Make sure you define all 4 components - normal, bold, italics, bolditalics - (even if they all point to the same font file)
    TimesNewRoman: {
      normal: 'Times-New-Roman-Regular.ttf',
      bold: 'Times-New-Roman-Bold.ttf',
      italics: 'Times-New-Roman-Italics.ttf',
      bolditalics: 'Times-New-Roman-Bold-Italics.ttf'
    },
    Corben: {
      normal: 'Corben-Regular.ttf',
      bold: 'Corben-Bold.ttf',
    },
    Devanagari: {
      normal: 'NotoSansDevanagari-Regular.ttf',
      // bold: 'NotoSansDevanagari-Regular.ttf',
    }
  }

  var docDefinition = {
    background: function (page) {
      return [
        {
          image: principalSign,
          width: 40,
          height: 40,
          absolutePosition: { x: 460, y: 347 }
        },
        {
          image: examController3,
          width: 60,
          height: 40,
          absolutePosition: { x: 276, y: 347 }
        },
        {
          image: principalSign,
          width: 40,
          height: 40,
          absolutePosition: { x: 460, y: 737 }
        },
        {
          image: examController3,
          width: 60,
          height: 40,
          absolutePosition: { x: 276, y: 737 }
        },
      ];
    },
    content: resultList.map(stResult => {
      return ([
        {
          image: 'logo',
          width: 50,
          height: 50,
          absolutePosition: { x: 60, y: 58 }
        },
        { text: 'Estd. 2016', style: 'logoEstdAndTrust', absolutePosition: { x: 69, y: 110 }, font: 'Roboto' },
        { text: 'B.M. Memorial Trust: 5815/204', style: 'logoEstdAndTrust', absolutePosition: { x: 40, y: 120 } },

        {
          stack: [
            { text: 'B.M. MEMORIAL SCHOOL', font: 'Corben' },
            { text: '(Run under BM Memorial Trust)', style: 'subheaderTrust', font: 'Roboto' },
            { text: 'BARKAGAON, HAZARIBAG', style: 'subheaderAdd' },
            { text: examName, style: 'subheaderExam' },
            { text: `Session: ${session}`, style: 'subheaderSession' },
          ],
          style: 'header'
        },
        {
          stack: [
            {
              text: ['REG. NO: ', { text: stResult[0].userId, bold: true }],
            },
            {
              text: ['STUDENT NAME: ', { text: stResult[0].fullName, bold: true }],
            },
            {
              text: ['CLASS: ', { text: selectedClass, bold: true }, { text: '                ROLL NO: ', bold: false }, { text: stResult[0].rollNumber, bold: true }],
            },
            {
              text: ['FATHER’S NAME: ', { text: stResult[0].fatherName, bold: true }],
            }
          ],
          style: 'stInfo'
        },
        { text: '_____________________________________________________________________________________', margin: [0, 0, 0, 2] },

        {
          fontSize: 12,
          table: {
            heights: [40, 40],
            widths: [52, 66, 66, 66, 66, 66, 66],
            body: [
              [
                {
                  image: writeRotatedText('SUBJECTS'),
                  fit: [20, 55],
                  margin: [18, -8, 0, 4],

                },
                { text: 'ENGLISH\n(80)', style: 'tableHeader', alignment: 'center', margin: [0, 12, 0, 0] },

                { text: 'HINDI\n(80)', style: 'tableHeader', alignment: 'center', margin: [0, 12, 0, 0] },

                { text: 'MATH\n(100)', style: 'tableHeader', alignment: 'center', margin: [0, 12, 0, 0] },

                { text: 'HINDI RHYMES\n(20)', style: 'tableHeader', alignment: 'center', margin: [0, 12, 0, 0] },

                { text: 'ENGLISH RHYMES\n(20)', style: 'tableHeader', alignment: 'center', margin: [0, 12, 0, 0] },

                { text: 'DRAWING\n(50)', style: 'tableHeader', alignment: 'center', margin: [0, 12, 0, 0] },
              ],
              [
                { text: 'MARKS\nOBTAINED', style: 'tableHeader', alignment: 'center', margin: [0, 12, 0, 0], fontSize: 9 },
                {
                  text: stResult[0].studentResult && stResult[0].studentResult.subjects && stResult[0].studentResult.subjects.english ? stResult[0].studentResult.subjects.english : 0,
                  alignment: 'center', margin: [0, 14, 0, 0], bold: false, fontSize: 14
                }, // ENGLISH 
                {
                  text: stResult[0].studentResult && stResult[0].studentResult.subjects && stResult[0].studentResult.subjects.hindi ? stResult[0].studentResult.subjects.hindi : 0,
                  alignment: 'center', margin: [0, 14, 0, 0], bold: false, fontSize: 14
                }, // HINDI 
                {
                  text: stResult[0].studentResult && stResult[0].studentResult.subjects && stResult[0].studentResult.subjects.math ? stResult[0].studentResult.subjects.math : 0,
                  alignment: 'center', margin: [0, 14, 0, 0], bold: false, fontSize: 14
                }, // MATH 
                {
                  text: stResult[0].studentResult && stResult[0].studentResult.subjects && stResult[0].studentResult.subjects.hindi_rhymes ? stResult[0].studentResult.subjects.hindi_rhymes : 0,
                  alignment: 'center', margin: [0, 14, 0, 0], bold: false, fontSize: 14
                }, // HINDI RHYMES
                {
                  text: stResult[0].studentResult && stResult[0].studentResult.subjects && stResult[0].studentResult.subjects.english_rhymes ? stResult[0].studentResult.subjects.english_rhymes : 0,
                  alignment: 'center', margin: [0, 14, 0, 0], bold: false, fontSize: 14
                },  // ENGLISH RHYMES
                {
                  text: stResult[0].studentResult && stResult[0].studentResult.subjects && stResult[0].studentResult.subjects.drawing ? stResult[0].studentResult.subjects.drawing : 0,
                  alignment: 'center', margin: [0, 14, 0, 0], bold: false, fontSize: 14
                },  // DRAWING
              ],
            ]
          },
        },
        //table End
        {
          stack: [
            {
              text:
                [
                  'TOTAL MARKS : ', { text: `${stResult[0].total}/${stResult[0].fullMarks}`, bold: true },
                  { text: '                 GRADE: ', bold: false }, { text: stResult[0].grade, bold: true },
                  { text: '                         ATTENDANCE: ', bold: false },
                  { text: `${selectedExamType === 'HALF YEARLY EXAM' ? stResult[0] && stResult[0].studentResult && stResult[0].studentResult.attendance1 ? stResult[0].studentResult.attendance1 : 0 : stResult[0].studentResult && stResult[0].studentResult.attendance2 ? stResult[0].studentResult.attendance2 : 0}/${stResult[0].fullAttendance}`, bold: true }
                ],
              preserveLeadingSpaces: true
            },
          ],
          style: 'marksAttendenceInfo'
        },
        {

          stack: [
            {
              text:
                [
                  'PERCENTAGE: ', { text: `${stResult[0].percentage}%`, bold: true },
                  { text: '                     RANK: ', bold: false }, { text: `${stResult[0].rank}/${allStudent}`, bold: true },
                  { text: '                       PERFORMANCE: ', bold: false }, { text: stResult[0] && stResult[0].performance, bold: true }
                ],
              preserveLeadingSpaces: true
            },
          ],
          style: 'marksAttendenceInfo'
        },
        {
          margin: [0, 40, 0, 0],
          stack: [
            {
              text:
                [
                  '          Class Teacher              ',
                  { text: '                        Exam Controller	      ' },
                  { text: '                            Principal          ' },

                ],
              preserveLeadingSpaces: true
            },
          ],
        },
        { text: '--------------------------------------------------------------------------------------------------------------------------------', margin: [0, 10, 0, 10] },
        {
          image: 'logo',
          width: 50,
          height: 50,
          absolutePosition: { x: 60, y: 445 }
        },
        { text: 'Estd. 2016', style: 'logoEstdAndTrust', absolutePosition: { x: 69, y: 497 }, font: 'Roboto' },
        { text: 'B.M. Memorial Trust: 5815/204', style: 'logoEstdAndTrust', absolutePosition: { x: 40, y: 507 } },

        {
          stack: [
            { text: 'B.M. MEMORIAL SCHOOL', font: 'Corben' },
            { text: '(Run under BM Memorial Trust)', style: 'subheaderTrust', font: 'Roboto' },
            { text: 'BARKAGAON, HAZARIBAG', style: 'subheaderAdd' },
            { text: examName, style: 'subheaderExam' },
            { text: `Session: ${session}`, style: 'subheaderSession' },
          ],
          style: 'header'
        },
        {
          stack: [
            {
              text: ['REG. NO: ', { text: stResult[1] && stResult[1].userId, bold: true }],
            },
            {
              text: ['STUDENT NAME: ', { text: stResult[1] && stResult[1].fullName, bold: true }],
            },
            {
              text: ['CLASS: ', { text: selectedClass, bold: true }, { text: '                ROLL NO: ', bold: false }, { text: stResult[1] && stResult[1].rollNumber, bold: true }],
            },
            {
              text: ['FATHER’S NAME: ', { text: stResult[1] && stResult[1].fatherName, bold: true }],
            }
          ],
          style: 'stInfo'
        },
        { text: '_____________________________________________________________________________________', margin: [0, 0, 0, 2] },

        {
          fontSize: 12,
          table: {
            heights: [40, 40],
            widths: [52, 66, 66, 66, 66, 66, 66],
            body: [
              [
                {
                  image: writeRotatedText('SUBJECTS'),
                  fit: [20, 55],
                  margin: [20, -8, 0, 5],

                },
                { text: 'ENGLISH\n(80)', style: 'tableHeader', alignment: 'center', margin: [0, 12, 0, 0] },

                { text: 'HINDI\n(80)', style: 'tableHeader', alignment: 'center', margin: [0, 12, 0, 0] },

                { text: 'MATH\n(100)', style: 'tableHeader', alignment: 'center', margin: [0, 12, 0, 0] },

                { text: 'HINDI RHYMES\n(20)', style: 'tableHeader', alignment: 'center', margin: [0, 12, 0, 0] },

                { text: 'ENGLISH RHYMES\n(20)', style: 'tableHeader', alignment: 'center', margin: [0, 12, 0, 0] },

                { text: 'DRAWING\n(50)', style: 'tableHeader', alignment: 'center', margin: [0, 12, 0, 0] },
              ],
              [
                { text: 'MARKS\nOBTAINED', style: 'tableHeader', alignment: 'center', margin: [0, 12, 0, 0], fontSize: 9 },
                {
                  text: stResult[1] && stResult[1].studentResult && stResult[1].studentResult.subjects && stResult[1].studentResult.subjects.english ? stResult[1].studentResult.subjects.english : 0,
                  alignment: 'center', margin: [0, 14, 0, 0], bold: false, fontSize: 14
                }, // ENGLISH 
                {
                  text: stResult[1] && stResult[1].studentResult && stResult[1].studentResult.subjects && stResult[1].studentResult.subjects.hindi ? stResult[1].studentResult.subjects.hindi : 0,
                  alignment: 'center', margin: [0, 14, 0, 0], bold: false, fontSize: 14
                }, // HINDI 
                {
                  text: stResult[1] && stResult[1].studentResult && stResult[1].studentResult.subjects && stResult[1].studentResult.subjects.math ? stResult[1].studentResult.subjects.math : 0,
                  alignment: 'center', margin: [0, 14, 0, 0], bold: false, fontSize: 14
                }, // MATH 
                {
                  text: stResult[1] && stResult[1].studentResult && stResult[1].studentResult.subjects && stResult[1].studentResult.subjects.hindi_rhymes ? stResult[1].studentResult.subjects.hindi_rhymes : 0,
                  alignment: 'center', margin: [0, 14, 0, 0], bold: false, fontSize: 14
                }, // HINDI RHYMES
                {
                  text: stResult[1] && stResult[1].studentResult && stResult[1].studentResult.subjects && stResult[1].studentResult.subjects.english_rhymes ? stResult[1].studentResult.subjects.english_rhymes : 0,
                  alignment: 'center', margin: [0, 14, 0, 0], bold: false, fontSize: 14
                },  // ENGLISH RHYMES
                {
                  text: stResult[1] && stResult[1].studentResult && stResult[1].studentResult.subjects && stResult[1].studentResult.subjects.drawing ? stResult[1].studentResult.subjects.drawing : 0,
                  alignment: 'center', margin: [0, 14, 0, 0], bold: false, fontSize: 14
                },  // DRAWING
              ],
            ]
          },
        },
        //table End

        {
          stack: [
            {
              text:
                [
                  'TOTAL MARKS : ', { text: `${stResult[1] && stResult[1].total}/${stResult[1] && stResult[1].fullMarks}`, bold: true },
                  { text: '                 GRADE: ', bold: false }, { text: stResult[1] && stResult[1].grade, bold: true },
                  { text: '                         ATTENDANCE: ', bold: false },
                  {
                    text: `${selectedExamType === 'HALF YEARLY EXAM' ? stResult[1] && stResult[1].studentResult && stResult[1].studentResult.attendance1 ? stResult[1] && stResult[1].studentResult.attendance1 : 0
                      : stResult[1] && stResult[1].studentResult && stResult[1].studentResult.attendance2 ? stResult[1].studentResult.attendance2 : 0}/${stResult[1] && stResult[1].fullAttendance ? stResult[1].fullAttendance : 0}`, bold: true
                  }
                ],
              preserveLeadingSpaces: true
            },
          ],
          style: 'marksAttendenceInfo'
        },
        {
          stack: [
            {
              text:
                [
                  'PERCENTAGE: ', { text: `${stResult[1] && stResult[1].percentage}%`, bold: true },
                  { text: '                     RANK: ', bold: false }, { text: `${stResult[1] && stResult[1].rank}/${allStudent}`, bold: true },
                  { text: '                       PERFORMANCE: ', bold: false }, { text: stResult[1] && stResult[1].performance, bold: true }
                ],
              preserveLeadingSpaces: true
            },
          ],
          style: 'marksAttendenceInfo'
        },

        {
          margin: [0, 40, 0, 0],
          stack: [
            {
              text:
                [
                  '          Class Teacher              ',
                  { text: '                        Exam Controller	      ' },
                  { text: '                            Principal          ' },
                ],
              preserveLeadingSpaces: true
            },
          ],
        },

      ])
    }),
    defaultStyle: {
      font: 'TimesNewRoman'
    },
    // to make library image
    images: {
      logo: schoolLogo
    },
    styles: {
      header: {
        fontSize: 22,
        bold: false,
        alignment: 'center',
        margin: [0, 5, 0, 0]
      },
      subheaderTrust: {
        fontSize: 10,
        bold: false
      },
      subheaderAdd: {
        fontSize: 10,
        bold: false
      },
      subheaderExam: {
        fontSize: 14,
        decoration: 'underline'
      },
      subheaderSession: {
        fontSize: 12,
        decoration: 'underline'
      },
      logoEstdAndTrust: {
        fontSize: 7,
      },
      stInfo: {
        fontSize: 12,
        alignment: 'left',
        margin: [0, 2, 0, 0]
      },

      tableHeader: {
        //bold: true,
        fontSize: 10,
        color: 'black',
      },
      marksAttendenceInfo: {
        fontSize: 12,
        alignment: 'left',
        margin: [0, 5, 0, 0]
      }
      // superMargin: {
      //   margin: [20, 0, 40, 0],
      //   fontSize: 15
      // }
    }
  };

  pdfMake.createPdf(docDefinition).open();
  //pdfMake.createPdf(docDefinition).download(`Result-report.pdf`) 

}

export const admitCardPdf = (listOfSt, selectedClass, examName, session, examDateAndSubList) => {



  pdfMake.fonts = {
    // Default font should still be available
    Roboto: {
      normal: 'Roboto-Regular.ttf',
      bold: 'Roboto-Medium.ttf',
      italics: 'Roboto-Italic.ttf',
      bolditalics: 'Roboto-Italic.ttf'
    },
    // Make sure you define all 4 components - normal, bold, italics, bolditalics - (even if they all point to the same font file)
    TimesNewRoman: {
      normal: 'Times-New-Roman-Regular.ttf',
      bold: 'Times-New-Roman-Bold.ttf',
      italics: 'Times-New-Roman-Italics.ttf',
      bolditalics: 'Times-New-Roman-Bold-Italics.ttf'
    },
    AbrilFatface: {
      normal: 'AbrilFatface-Regular.ttf',
    },
  }

  const convertArrayToBase64 = async (data) => {
    return Promise.all(
      data.map(async (eleme) => {
        let newList = []
        for (let index = 0; index < eleme.length; index++) {
          const item = eleme[index];
          if (item.document && item.document.stPhoto) {
            try {
              const base64Image = await urlToBase64(item.document.stPhoto);
              if (base64Image) {
                eleme[index] = {
                  ...item, // Keep all other properties intact
                  document: {
                    ...item.document,
                    stPhoto: base64Image, // Replace URL with Base64
                  },
                }
                newList.push(eleme[index])
              } else {
                eleme[index] = {
                  ...item, // Keep all other properties intact
                  document: {
                    ...item.document,
                    stPhoto: ''
                  },
                };
                newList.push(eleme[index])
              }
            } catch (error) {
              eleme[index] = {
                ...item, // Keep all other properties intact
                document: {
                  ...item.document,
                  stPhoto: ''
                },
              };
              newList.push(eleme[index])
            }
          } else {
            eleme[index] = {
              ...item, // Keep all other properties intact
              document: {
                ...item.document,
                stPhoto: ''
              },
            };
            newList.push(eleme[index])
          }
        }
        return newList
      })
    );
  }

  (async () => {
    try {
      const resultArray = await convertArrayToBase64(listOfSt);
      const totalPage = resultArray.length
      var docDefinition = {
        background: function (page) {
          return [
            //{ text: '(Run under BM Memorial Trust)', style: 'subheaderExam' },
            {
              image: principalSign,
              width: 40,
              height: 40,
              absolutePosition: { x: 80, y: 155 }
            },
            {
              image: slogan,
              width: 120,
              height: 16,
              absolutePosition: { x: 230, y: 248 }
            },
            {
              image: principalSign,
              width: 40,
              height: 40,
              absolutePosition: { x: 80, y: 422 }
            },
            {
              image: slogan,
              width: 120,
              height: 16,
              absolutePosition: { x: 230, y: 518 }
            },
            {
              image: principalSign,
              width: 40,
              height: 40,
              absolutePosition: { x: 80, y: 688 }
            },
            {
              image: slogan,
              width: 120,
              height: 16,
              absolutePosition: { x: 230, y: 780 }
            },
          ];
        },
        content: resultArray.map((st, index) => {
          return ([

            {
              canvas: [
                // Draw a rectangle as the border
                {
                  type: "rect",
                  x: 0,
                  y: 0,
                  w: 85,
                  h: 100,
                  r: 2, // Optional: Rounded corners
                  lineWidth: 2, // Border thickness
                  lineColor: photoBorderColor, // Border color
                },
              ],
              absolutePosition: { x: 460, y: 50 }, // Position of the border
            },
            //student photo
            st[0]?.document?.stPhoto ?
              {
                image: st[0].document.stPhoto,
                width: 80, // Fit inside the border (slightly smaller than border size)
                height: 95,
                absolutePosition: { x: 463, y: 52 }, // Position image inside the border
              } :
              {
                canvas: [
                  {
                    type: "rect", // Placeholder rectangle
                    x: 0,
                    y: 0,
                    w: 80,
                    h: 95,
                    color: "#FFFFFF", // White fill
                  },
                ],
                //margin: [-1, -100, 0, 0], // Adjust rectangle to align with the border
                absolutePosition: { x: 463, y: 52 }
              },
            {
              image: 'logo',
              width: 35,
              height: 35,
              absolutePosition: { x: 60, y: 45 }
            },
            { text: 'Estd. 2016', style: 'logoEstdAndTrust', absolutePosition: { x: 63, y: 80 }, font: 'Roboto', fontSize: 6 },
            {
              stack: [
                { text: 'B.M. MEMORIAL SCHOOL', font: 'AbrilFatface', },
                { text: 'ADMIT CARD', fontSize: 14, decoration: 'underline' },
                { text: `${examName} ${session}`, fontSize: 14, decoration: 'underline' },
              ],
              style: 'header'
            },
            {
              stack: [
                {
                  text: ['REG. NO: ', { text: st[0] && st[0].userInfo.userId, bold: true },], style: 'stInfoMargin'
                },
                {
                  text: ['NAME: ', { text: st[0] && st[0].userInfo.fullName, bold: true }], style: 'stInfoMargin'
                },
                {
                  text: ['CLASS: ', { text: romanClassConvert(selectedClass), bold: true }, { text: '                ROLL NO: ', bold: false }, { text: st[0] && st[0].rollNumber, bold: true }], style: 'stInfoMargin'
                },
                {
                  text: ['FATHER’S NAME: ', { text: st[0] && st[0].userInfo.fatherName, bold: true }], style: 'stInfoMargin'
                }
              ],
              style: 'stInfo'
            },
            {
              margin: [0, 25, 0, 0],
              stack: [
                {
                  text:
                    [
                      '        Principal Sign                                  ',
                      { text: '                                                                     Student Sign    ', bold: false },

                    ],
                  preserveLeadingSpaces: true
                },
              ],
            },
            {
              margin: [0, 5, 0, 10],
              fontSize: 9,
              bold: true,
              table: {
                body:
                  [
                    [
                      { text: 'DATE', alignment: 'center' },
                      ...examDateAndSubList.map((dateList, index) => { return { text: dateList[`date${index + 1}`], alignment: 'center' } })
                    ],
                    [
                      { text: 'SUBJECT', alignment: 'center' },
                      ...examDateAndSubList.map((subList, index) => { return { text: subList[`sub${index + 1}`], alignment: 'center' } })
                    ],

                  ]
              },
            },
            { text: '--------------------------------------------------------------------------------------------------------------------------------', margin: [0, 20, 0, 20] },
            {
              canvas: [
                // Draw a rectangle as the border
                {
                  type: "rect",
                  x: 0,
                  y: 0,
                  w: 85,
                  h: 100,
                  r: 2, // Optional: Rounded corners
                  lineWidth: 2, // Border thickness
                  lineColor: photoBorderColor, // Border color
                },
              ],
              absolutePosition: { x: 460, y: 303 }, // Position of the border
            },
            //student photo
            st[1]?.document?.stPhoto ?
              {
                image: st[1].document.stPhoto,
                width: 80, // Fit inside the border (slightly smaller than border size)
                height: 95,
                absolutePosition: { x: 463, y: 305 }, // Position image inside the border
              } :
              {
                canvas: [
                  {
                    type: "rect", // Placeholder rectangle
                    x: 0,
                    y: 0,
                    w: 80,
                    h: 95,
                    color: "#FFFFFF", // White fill
                  },
                ],
                //margin: [-1, -100, 0, 0], // Adjust rectangle to align with the border
                absolutePosition: { x: 463, y: 305 }
              },
            {
              image: 'logo',
              width: 35,
              height: 35,
              absolutePosition: { x: 60, y: 300 }
            },
            { text: 'Estd. 2016', style: 'logoEstdAndTrust', absolutePosition: { x: 63, y: 335 }, font: 'Roboto', fontSize: 6 },
            {
              stack: [
                { text: 'B.M. MEMORIAL SCHOOL', font: 'AbrilFatface' },
                { text: 'ADMIT CARD', fontSize: 14, decoration: 'underline' },
                { text: `${examName} ${session}`, fontSize: 14, decoration: 'underline' },
              ],
              style: 'header'
            },
            {
              stack: [
                {
                  text: ['REG. NO: ', { text: st[1] && st[1].userInfo.userId, bold: true }], style: 'stInfoMargin'
                },
                {
                  text: ['NAME: ', { text: st[1] && st[1].userInfo.fullName, bold: true }], style: 'stInfoMargin'
                },
                {
                  text: ['CLASS: ', { text: romanClassConvert(selectedClass), bold: true }, { text: '                ROLL NO: ', bold: false }, { text: st[1] && st[1].rollNumber, bold: true }], style: 'stInfoMargin'
                },
                {
                  text: ['FATHER’S NAME: ', { text: st[1] && st[1].userInfo.fatherName, bold: true }], style: 'stInfoMargin'
                }
              ],
              style: 'stInfo'
            },
            {
              margin: [0, 25, 0, 0],
              stack: [
                {
                  text:
                    [
                      '        Principal Sign                                  ',
                      { text: '                                                                     Student Sign    ', bold: false },

                    ],
                  preserveLeadingSpaces: true
                },
              ],
            },
            {
              margin: [0, 5, 0, 10],
              fontSize: 9,
              bold: true,
              table: {
                body:
                  [
                    [
                      { text: 'DATE', alignment: 'center' },
                      ...examDateAndSubList.map((dateList, index) => { return { text: dateList[`date${index + 1}`], alignment: 'center' } })
                    ],
                    [
                      { text: 'SUBJECT', alignment: 'center' },
                      ...examDateAndSubList.map((subList, index) => { return { text: subList[`sub${index + 1}`], alignment: 'center' } })
                    ],
                  ]
              },
            },
            { text: '--------------------------------------------------------------------------------------------------------------------------------', margin: [0, 20, 0, 20] },
            {
              canvas: [
                // Draw a rectangle as the border
                {
                  type: "rect",
                  x: 0,
                  y: 0,
                  w: 85,
                  h: 100,
                  r: 2, // Optional: Rounded corners
                  lineWidth: 2, // Border thickness
                  lineColor: photoBorderColor, // Border color
                },
              ],
              absolutePosition: { x: 460, y: 560 }, // Position of the border
            },
            //student photo
            st[2]?.document?.stPhoto ?
              {
                image: st[2].document.stPhoto,
                width: 80, // Fit inside the border (slightly smaller than border size)
                height: 95,
                absolutePosition: { x: 463, y: 562 }, // Position image inside the border
              } :
              {
                canvas: [
                  {
                    type: "rect", // Placeholder rectangle
                    x: 0,
                    y: 0,
                    w: 80,
                    h: 95,
                    color: "#FFFFFF", // White fill
                  },
                ],
                //margin: [-1, -100, 0, 0], // Adjust rectangle to align with the border
                absolutePosition: { x: 463, y: 562 }
              },
            {
              image: 'logo',
              width: 35,
              height: 35,
              absolutePosition: { x: 60, y: 560 }
            },
            { text: 'Estd. 2016', style: 'logoEstdAndTrust', absolutePosition: { x: 63, y: 595 }, font: 'Roboto', fontSize: 6 },
            {
              stack: [
                { text: 'B.M. MEMORIAL SCHOOL', font: 'AbrilFatface' },
                { text: 'ADMIT CARD', fontSize: 14, decoration: 'underline' },
                { text: `${examName} ${session}`, fontSize: 14, decoration: 'underline' },
              ],
              style: 'header'
            },
            {
              stack: [
                {
                  text: ['REG. NO: ', { text: st[2] && st[2].userInfo.userId, bold: true }], style: 'stInfoMargin'
                },
                {
                  text: ['NAME: ', { text: st[2] && st[2].userInfo.fullName, bold: true }], style: 'stInfoMargin'
                },
                {
                  text: ['CLASS: ', { text: romanClassConvert(selectedClass), bold: true }, { text: '                ROLL NO: ', bold: false }, { text: st[2] && st[2].rollNumber, bold: true }], style: 'stInfoMargin'
                },
                {
                  text: ['FATHER’S NAME: ', { text: st[2] && st[2].userInfo.fatherName, bold: true }], style: 'stInfoMargin'
                }
              ],
              style: 'stInfo'
            },
            {
              margin: [0, 25, 0, 0],
              stack: [
                {
                  text:
                    [
                      '        Principal Sign                                  ',
                      { text: '                                                                     Student Sign    ', bold: false },

                    ],
                  preserveLeadingSpaces: true
                },
              ],
            },
            {
              margin: [0, 5, 0, 0],
              fontSize: 9,
              bold: true,
              table: {
                body:
                  [
                    [
                      { text: 'DATE', alignment: 'center' },
                      ...examDateAndSubList.map((dateList, index) => { return { text: dateList[`date${index + 1}`], alignment: 'center' } })
                    ],
                    [
                      { text: 'SUBJECT', alignment: 'center' },
                      ...examDateAndSubList.map((subList, index) => { return { text: subList[`sub${index + 1}`], alignment: 'center' } })
                    ],
                  ]
              },
            },
            { text: '', pageBreak: `${totalPage === (index + 1) ? '' : 'after'}` }
          ]
          )
        }),

        defaultStyle: {
          font: 'TimesNewRoman',
          color: '#404040',
        },
        //to make library image
        images: {
          logo: schoolLogo
        },
        styles: {
          header: {
            fontSize: 22,
            bold: false,
            alignment: 'center',
          },
          stInfoMargin: {
            margin: [0, 0, 0, 1]
          },
        },
      };

      pdfMake.createPdf(docDefinition).open();
      //pdfMake.createPdf(docDefinition).download(`Result-report.pdf`) 
    } catch (error) {
      console.error("Error converting images:", error);
    }
  })();

}

export const result1to8Pdf = (resultList, examName, session, selectedClass) => {

  const colName = examName.includes('HALF') ? 'HMO' : 'AMO'
  const classPrimary = Number(selectedClass.split(' ')[0]) > 3 ? false : true
  const class5to8 = Number(selectedClass.split(' ')[0]) >= 5 && Number(selectedClass.split(' ')[0]) <= 8 ? true : false
  pdfMake.fonts = {
    // Default font should still be available
    Roboto: {
      normal: 'Roboto-Regular.ttf',
      bold: 'Roboto-Medium.ttf',
      italics: 'Roboto-Italic.ttf',
      bolditalics: 'Roboto-Italic.ttf'
    },
    // Make sure you define all 4 components - normal, bold, italics, bolditalics - (even if they all point to the same font file)
    TimesNewRoman: {
      normal: 'Times-New-Roman-Regular.ttf',
      bold: 'Times-New-Roman-Bold.ttf',
      italics: 'Times-New-Roman-Italics.ttf',
      bolditalics: 'Times-New-Roman-Bold-Italics.ttf'
    },
    Corben: {
      normal: 'Corben-Regular.ttf',
      bold: 'Corben-Bold.ttf',
    },
    GreatVibes: {
      normal: 'GreatVibes-Regular.ttf',
    }
  }
  var docDefinition = {
    background: function (page) {
      return [
        //{ text: '(Run under BM Memorial Trust)', style: 'subheaderExam' },
        {
          image: 'logo',
          width: 50,
          height: 50,
          absolutePosition: { x: 60, y: 60 }
        },
        { text: 'Estd. 2016', style: 'logoEstdAndTrust', absolutePosition: { x: 71, y: 112 }, font: 'Roboto' },
        { text: 'B.M. Memorial Trust: 5815/204', style: 'logoEstdAndTrust', absolutePosition: { x: 40, y: 122 } },
        {
          image: classPrimary ? examController3 : examController1,
          width: classPrimary ? 60 : 80,
          height: classPrimary ? 40 : 25,
          absolutePosition: { x: 262, y: 730 }
        },
        {
          image: principalSign,
          width: 40,
          height: 40,
          absolutePosition: { x: 455, y: 722 }
        },
      ];
    },
    content: resultList.map(function (result, index) {
      const attendence = examName === 'ANNUAL EXAM' ? result.studentResultSecond.attendance2 : result.studentResultSecond.attendance1
      const resultExamHeader = examName === 'ANNUAL EXAM' ? 'ANNUAL EXAMINATION RESULT' : 'HALF YEARLY EXAMINATION RESULT'
      return ([
        {
          stack: [
            { text: 'B.M. MEMORIAL SCHOOL', font: 'Corben' },
            { text: '(Run under BM Memorial Trust)', style: 'subheaderTrust', font: 'Roboto' },
            { text: 'BARKAGAON, HAZARIBAG', style: 'subheaderAdd' },
            { text: resultExamHeader, style: 'subheaderExam' },
            { text: `Session: ${session}`, style: 'subheaderSession' },
          ],
          style: 'header'
        },
        {
          stack: [
            {
              text: ['REG. NO: ', { text: result.userId, bold: true }],
            },
            {
              text: ['STUDENT NAME: ', { text: result.fullName, bold: true }],
            },
            {
              text: ['CLASS: ', { text: romanClassConvert(result.class), bold: true }, { text: '                ROLL NO: ', bold: false }, { text: result.rollNumber, bold: true }],
            },
            {
              text: ['FATHER’S NAME: ', { text: result.fatherName, bold: true }],
            }
          ],
          style: 'stInfo'
        },
        { text: '_____________________________________________________________________________________', margin: [0, 0, 0, 2] },
        {
          fontSize: 10,
          table: {
            heights: [40, 50, 62, 70],
            widths: [20, 22, 22, 21, 21, 21, 21, 21, 21, 21, 21, 21, 32, 34, 23, 23],
            //headerRows: 2,
            // keepWithHeaderRows: 1,
            body: [
              [
                {
                  image: writeRotatedText('SUBJECTS'),
                  fit: [20, 60],
                  margin: [5, -8, 0, 5],
                  //alignment: 'centre',
                  //absolutePosition: { x: 70, y: 125 },
                },
                //{ text: 'Header 3', style: 'tableHeader', alignment: 'center', angle: 90 },
                { text: 'ENGLISH\n(100)', style: 'tableHeader', colSpan: 2, alignment: 'center' },
                {},
                { text: 'HINDI\n(100)', style: 'tableHeader', colSpan: 2, alignment: 'center' },
                {},
                { text: 'MATH\n(100)', style: 'tableHeader', colSpan: 2, alignment: 'center' },
                {},
                { text: 'SCIENCE\n(100)', style: 'tableHeader', colSpan: 2, alignment: 'center' },
                {},
                { text: 'SST\n(100)', style: 'tableHeader', colSpan: 2, alignment: 'center' },
                {},
                { text: 'COMPUTER\n(80)', style: 'tableHeader', colSpan: 2, alignment: 'center' },
                {},
                { text: 'COMPUTER PRACTICAL\n(20)', style: 'tableHeader', alignment: 'center' },
                //{text: 'COMP\nUTER\nPRAC\nTICAL\n(20)', style: 'tableHeader', alignment: 'center'},
                { text: 'G.K.\n/\nM.V.\n(50)', style: 'tableHeader', alignment: 'center' },
                { text: `${['5', '6', '7', '8'].includes(result.class?.split(' ')[0]) ? 'Art & Craft' : 'DRAWING'}\n(50)`, style: 'tableHeader', alignment: 'center' },
                // { text: `${class5to8 ? 'G.K.\n/\nM.V.\n(50)' : 'G.K.\n/\nM.V.\n(50)'}`, style: 'tableHeader', alignment: 'center' },
                // { text: `${class5to8 ? 'Art & Craft' : 'DRAWING'}\n(50)`, style: 'tableHeader', alignment: 'center' },
              ],
              [
                {},
                {
                  image: writeRotatedText('UNIT TEST'),
                  fit: [20, 60],
                  margin: [5, -10, 0, 0],
                  //alignment: 'centre',
                  //absolutePosition: { x: 70, y: 125 },
                },
                {
                  image: writeRotatedText(colName),
                  fit: [20, 60],
                  margin: [5, -10, 0, 0],
                  //alignment: 'centre',
                  //absolutePosition: { x: 70, y: 125 },
                },
                {
                  image: writeRotatedText('UNIT TEST'),
                  fit: [20, 60],
                  margin: [5, -10, 0, 0],
                  //alignment: 'centre',
                  //absolutePosition: { x: 70, y: 125 },
                },
                {
                  image: writeRotatedText(colName),
                  fit: [20, 60],
                  margin: [5, -10, 0, 0],
                  //alignment: 'centre',
                  //absolutePosition: { x: 70, y: 125 },
                },
                {
                  image: writeRotatedText('UNIT TEST'),
                  fit: [20, 60],
                  margin: [5, -10, 0, 0],
                  //alignment: 'centre',
                  //absolutePosition: { x: 70, y: 125 },
                },
                {
                  image: writeRotatedText(colName),
                  fit: [20, 60],
                  margin: [5, -10, 0, 0],
                  //alignment: 'centre',
                  //absolutePosition: { x: 70, y: 125 },
                },
                {
                  image: writeRotatedText('UNIT TEST'),
                  fit: [20, 60],
                  margin: [5, -10, 0, 0],
                  //alignment: 'centre',
                  //absolutePosition: { x: 70, y: 125 },
                },
                {
                  image: writeRotatedText(colName),
                  fit: [20, 60],
                  margin: [5, -10, 0, 0],
                  //alignment: 'centre',
                  //absolutePosition: { x: 70, y: 125 },
                },
                {
                  image: writeRotatedText('UNIT TEST'),
                  fit: [20, 60],
                  margin: [5, -10, 0, 0],
                  //alignment: 'centre',
                  //absolutePosition: { x: 70, y: 125 },
                },
                {
                  image: writeRotatedText(colName),
                  fit: [20, 60],
                  margin: [5, -10, 0, 0],
                  //alignment: 'centre',
                  //absolutePosition: { x: 70, y: 125 },
                },
                {
                  image: writeRotatedText('UNIT TEST'),
                  fit: [20, 60],
                  margin: [5, -10, 0, 0],
                  //alignment: 'centre',
                  //absolutePosition: { x: 70, y: 125 },
                },
                {
                  image: writeRotatedText(colName),
                  fit: [20, 60],
                  margin: [5, -10, 0, 0],
                  //alignment: 'centre',
                  //absolutePosition: { x: 70, y: 125 },
                },
                {},
                {},
                {},
              ],
              [
                {
                  image: writeRotatedText('PASS MARKS'),
                  fit: [20, 60],
                  margin: [5, 0, 0, 0],
                  //alignment: 'centre',
                  //absolutePosition: { x: 70, y: 125 },
                },
                { text: '33', style: 'tableHeader', colSpan: 2, alignment: 'center', margin: [0, 25, 0, 0] },
                {},
                { text: '33', style: 'tableHeader', colSpan: 2, alignment: 'center', margin: [0, 25, 0, 0] },
                {},
                { text: '33', style: 'tableHeader', colSpan: 2, alignment: 'center', margin: [0, 25, 0, 0] },
                {},
                { text: '33', style: 'tableHeader', colSpan: 2, alignment: 'center', margin: [0, 25, 0, 0] },
                {},
                { text: '33', style: 'tableHeader', colSpan: 2, alignment: 'center', margin: [0, 25, 0, 0] },
                {},
                { text: '24', style: 'tableHeader', colSpan: 2, alignment: 'center', margin: [0, 25, 0, 0] },
                {},
                { text: '10', style: 'tableHeader', alignment: 'center', margin: [0, 25, 0, 0] },
                { text: '18', style: 'tableHeader', alignment: 'center', margin: [0, 25, 0, 0] },
                { text: '18', style: 'tableHeader', alignment: 'center', margin: [0, 25, 0, 0] },
              ],
              [
                {
                  image: writeRotatedText2('MARKS OBTAINED'),
                  fit: [20, 80],
                  //alignment: 'centre',
                  margin: [5, -4, 0, 0]
                  //absolutePosition: { x: 70, y: 125 },
                },
                {
                  text: result.studentResult && result.studentResult.subjects && result.studentResult.subjects.english ? result.studentResult.subjects.english : 0,
                  alignment: 'center', margin: [0, 30, 0, 0]
                }, // ENGLISH unit 
                {
                  text: result.studentResultSecond && result.studentResultSecond.subjects && result.studentResultSecond.subjects.english ? result.studentResultSecond.subjects.english : 0,
                  alignment: 'center', margin: [0, 30, 0, 0]
                }, // ENGLISH Annual
                {
                  text: result.studentResult && result.studentResult.subjects && result.studentResult.subjects.hindi ? result.studentResult.subjects.hindi : 0,
                  alignment: 'center', margin: [0, 30, 0, 0]
                }, // HINDI unit
                {
                  text: result.studentResultSecond && result.studentResultSecond.subjects && result.studentResultSecond.subjects.hindi ? result.studentResultSecond.subjects.hindi : 0,
                  alignment: 'center', margin: [0, 30, 0, 0]
                }, // HINDI Annual
                {
                  text: result.studentResult && result.studentResult.subjects && result.studentResult.subjects.math ? result.studentResult.subjects.math : 0,
                  alignment: 'center', margin: [0, 30, 0, 0]
                },  // MATH unit
                {
                  text: result.studentResultSecond && result.studentResultSecond.subjects && result.studentResultSecond.subjects.math ? result.studentResultSecond.subjects.math : 0,
                  alignment: 'center', margin: [0, 30, 0, 0]
                },  // MATH Annual
                {
                  text: result.studentResult && result.studentResult.subjects && result.studentResult.subjects.science ? result.studentResult.subjects.science : 0,
                  alignment: 'center', margin: [0, 30, 0, 0]
                },  // SCIENCE unit
                {
                  text: result.studentResultSecond && result.studentResultSecond.subjects && result.studentResultSecond.subjects.science ? result.studentResultSecond.subjects.science : 0,
                  alignment: 'center', margin: [0, 30, 0, 0]
                },  // SCIENCE Annual
                {
                  text: result.studentResult && result.studentResult.subjects && result.studentResult.subjects.sst ? result.studentResult.subjects.sst : 0,
                  alignment: 'center', margin: [0, 30, 0, 0]
                },  // SST unit
                {
                  text: result.studentResultSecond && result.studentResultSecond.subjects && result.studentResultSecond.subjects.sst ? result.studentResultSecond.subjects.sst : 0,
                  alignment: 'center', margin: [0, 30, 0, 0]
                },  // SST Annual
                {
                  text: result.studentResult && result.studentResult.subjects && result.studentResult.subjects.computer ? result.studentResult.subjects.computer : 0,
                  alignment: 'center', margin: [0, 30, 0, 0]
                },  // COMPUTER unit
                {
                  text: result.studentResultSecond && result.studentResultSecond.subjects && result.studentResultSecond.subjects.computer ? result.studentResultSecond.subjects.computer : 0,
                  alignment: 'center', margin: [0, 30, 0, 0]
                },  // COMPUTER Annual
                {
                  text: result.studentResultSecond && result.studentResultSecond.subjects && result.studentResultSecond.subjects.comp_pract ? result.studentResultSecond.subjects.comp_pract : 0,
                  alignment: 'center', margin: [0, 30, 0, 0]
                },  // COMPUTER Practical 
                {
                  text: result.studentResultSecond && result.studentResultSecond.subjects && result.studentResultSecond.subjects.gk_mv ? result.studentResultSecond.subjects.gk_mv : 0,
                  alignment: 'center', margin: [0, 30, 0, 0]
                },  // G.K./ M.V.
                {
                  text: result.studentResultSecond && result.studentResultSecond.subjects && result.studentResultSecond.subjects.drawing ? result.studentResultSecond.subjects.drawing : 0,
                  alignment: 'center', margin: [0, 30, 0, 0]
                },  //  DRWAING
              ],
              [
                {
                  border: [false, true, false, false],
                  text: ''
                },
                {
                  border: [false, true, false, false],
                  text: ''
                },
                {
                  border: [false, true, false, false],
                  text: ''
                },
                {
                  border: [false, true, false, false],
                  text: ''
                },
                {
                  border: [false, true, false, false],
                  text: ''
                },
                {
                  border: [false, true, false, false],
                  text: ''
                },
                {
                  border: [false, true, false, false],
                  text: ''
                },
                {
                  border: [false, true, false, false],
                  text: ''
                },
                {
                  border: [false, true, false, false],
                  text: ''
                },
                {
                  border: [false, true, false, false],
                  text: ''
                },
                {
                  border: [false, true, false, false],
                  text: ''
                },
                {
                  border: [false, true, false, false],
                  text: ''
                },
                { text: 'GRADE', style: 'tableHeader', colSpan: 2, alignment: 'center', fontSize: 12 },
                {},
                { text: result.grade, style: 'tableHeader', colSpan: 2, alignment: 'center', bold: true, fontSize: 12 },
                {},
              ],

            ]
          }
        },
        //table End
        {
          margin: [10, 10, 0, 0],
          stack: [
            {
              text: ['TOTAL MARKS OBTAINED: ', { text: `${result.total}/${result.fullMarks}        `, bold: true }, { text: '                ATTENDANCE: ', bold: false }, { text: `${attendence}/${result.fullAttendance}`, bold: true }],
            },
          ],
          style: 'marksAttendenceInfo'
        },
        {
          fontSize: 10,
          margin: [0, 5, 0, 0],
          table: {
            widths: [250, 250],
            body: [
              [
                {
                  border: [false, false, false, false],
                  fontSize: 10,
                  table: {
                    widths: [120],
                    body: [
                      [{ type: 'square', ul: ['91 -100    : A1'] }],
                      [{ type: 'square', ul: ['81 - 90     : A2'] }],
                      [{ type: 'square', ul: ['71 - 80     : B1'] }],
                      [{ type: 'square', ul: ['61 - 70     : B2'] }],
                      [{ type: 'square', ul: ['51 - 60     : C1'] }],
                      [{ type: 'square', ul: ['41 - 50     : C2'] }],
                      [{ type: 'square', ul: ['33 - 40     :  D'] }],
                      [{ type: 'square', ul: ['32 & Below E ( Needs to Improvement)'] }],
                    ]
                  }
                },
                {
                  border: [false, false, false, false],
                  fontSize: 11,
                  table: {
                    widths: [100, 80],
                    body: [
                      [{ text: 'Work Education', alignment: 'centre' }, { text: 'Good / Average', alignment: 'centre' }],
                      [{ text: 'Art Education', alignment: 'centre' }, { text: 'Good / Average', alignment: 'centre' }],
                      [{ text: 'Physical Education', alignment: 'centre' }, { text: 'Good / Average', alignment: 'centre' }],
                      [{ text: 'Discipline', alignment: 'centre' }, { text: 'Good / Average', alignment: 'centre' }],
                      [{ text: 'Extra Curricular', alignment: 'centre' }, { text: 'Good / Average', alignment: 'centre' }],
                    ]
                  }
                },

              ]
            ]
          }
        },
        {

          stack: [
            {
              text:
                [
                  'PERCENTAGE: ', { text: `${result.percentage}%        `, bold: true },
                  { text: '            RANK: ', bold: false }, { text: `${result.rank}/${resultList.length}`, bold: true },
                  { text: '                PERFORMANCE: ', bold: false }, { text: result.performance, fontSize: 18, font: 'GreatVibes' }
                ],
            },
          ],
          style: 'marksAttendenceInfo'
        },

        {
          margin: [0, 60, 0, 0],
          stack: [
            {
              text:
                [
                  '          Class Teacher              ',
                  { text: '                        Exam Controller	      ' }, { text: '                         Principal          ' },

                ],
              preserveLeadingSpaces: true
            },
          ],
        },
        {
          canvas: [
            // Draw a rectangle as the border
            {
              type: "rect",
              x: 0,
              y: 0,
              w: 85,
              h: 100,
              r: 2, // Optional: Rounded corners
              lineWidth: 2, // Border thickness
              lineColor: photoBorderColor, // Border color
            },
          ],
          absolutePosition: { x: 460, y: 85 }, // Position of the border
        },
        //student photo — guard against empty string / failed download
        (result.document && typeof result.document.stPhoto === 'string' && result.document.stPhoto.startsWith('data:image/')) ?
          {
            image: result.document.stPhoto,
            width: 80, // Fit inside the border (slightly smaller than border size)
            height: 95,
            absolutePosition: { x: 463, y: 87 }, // Position image inside the border
          } :
          {
            canvas: [
              {
                type: "rect", // Placeholder rectangle
                x: 0,
                y: 0,
                w: 80,
                h: 95,
                color: "#FFFFFF", // White fill
              },
            ],
            //margin: [-1, -100, 0, 0], // Adjust rectangle to align with the border
            absolutePosition: { x: 463, y: 87 }
          },

      ])
    }),
    defaultStyle: {
      font: 'TimesNewRoman'
    },
    // to make library image
    images: {
      logo: schoolLogo
    },
    styles: {
      header: {
        fontSize: 22,
        bold: false,
        alignment: 'center',
        margin: [0, 5, 0, 0]
      },
      subheaderTrust: {
        fontSize: 10,
        bold: false
      },
      subheaderAdd: {
        fontSize: 10,
        bold: false
      },
      subheaderExam: {
        fontSize: 14,
        decoration: 'underline'
      },
      subheaderSession: {
        fontSize: 12,
        decoration: 'underline'
      },
      logoEstdAndTrust: {
        fontSize: 7,
      },
      stInfo: {
        fontSize: 12,
        alignment: 'left',
        margin: [0, 10, 0, 0]
      },

      tableHeader: {
        //bold: true,
        fontSize: 10,
        color: 'black',
      },
      marksAttendenceInfo: {
        fontSize: 12,
        alignment: 'left',
        margin: [0, 10, 0, 0]
      }
      // superMargin: {
      //   margin: [20, 0, 40, 0],
      //   fontSize: 15
      // }
    }
  };

  pdfMake.createPdf(docDefinition).open();
  //pdfMake.createPdf(docDefinition).download(`Result-report.pdf`) 
  //   } catch (error) {
  //     console.error("Error converting images:", error);
  //   }
  // })();     
}

export const result9to10Pdf = (resultList, examName, session, selectedClass) => {

  pdfMake.fonts = {
    // Default font should still be available
    Roboto: {
      normal: 'Roboto-Regular.ttf',
      bold: 'Roboto-Medium.ttf',
      italics: 'Roboto-Italic.ttf',
      bolditalics: 'Roboto-Italic.ttf'
    },
    // Make sure you define all 4 components - normal, bold, italics, bolditalics - (even if they all point to the same font file)
    TimesNewRoman: {
      normal: 'Times-New-Roman-Regular.ttf',
      bold: 'Times-New-Roman-Bold.ttf',
      italics: 'Times-New-Roman-Italics.ttf',
      bolditalics: 'Times-New-Roman-Bold-Italics.ttf'
    },
    Corben: {
      normal: 'Corben-Regular.ttf',
      bold: 'Corben-Bold.ttf',
    }
  }

  var docDefinition = {
    background: function (page) {
      return [
        //{ text: '(Run under BM Memorial Trust)', style: 'subheaderExam' },
        {
          image: 'logo',
          width: 50,
          height: 50,
          absolutePosition: { x: 60, y: 60 }
        },
        { text: 'Estd. 2016', style: 'logoEstdAndTrust', absolutePosition: { x: 71, y: 112 }, font: 'Roboto' },
        { text: 'B.M. Memorial Trust: 5815/204', style: 'logoEstdAndTrust', absolutePosition: { x: 40, y: 122 } },
        {
          image: examController1,
          width: 80,
          height: 25,
          absolutePosition: { x: 262, y: 742 }
        },
        {
          image: principalSign,
          width: 40,
          height: 40,
          absolutePosition: { x: 455, y: 735 }
        },
      ];
    },
    content: resultList.map((result, index) => {
      const attendence = examName === 'ANNUAL EXAM' ? result.studentResultSecond.attendance2 : result.studentResultSecond.attendance1
      const resultExamHeader = examName === 'ANNUAL EXAM' ? 'ANNUAL EXAMINATION RESULT' : 'HALF YEARLY EXAMINATION RESULT'
      const subColmName = 'HM' // Highest Marks
      const subMainData = result && result.studentResultSecond && result.studentResultSecond.subjects ? result.studentResultSecond.subjects : {}
      const subUnitData = result && result.studentResult && result.studentResult.subjects ? result.studentResult.subjects : {}

      const unitEnglish = (subUnitData.english && subUnitData.english) ? (Number(subUnitData.english) / 2).toFixed(1) : 0.0
      const english_notes = (subMainData.english_notes && subMainData.english_notes) ? Number(subMainData.english_notes) : 0.0
      const english_sub_enrich = (subMainData.english_sub_enrich && subMainData.english_sub_enrich) ? Number(subMainData.english_sub_enrich) : 0.0
      const mainEnglish = (subMainData.english && subMainData.english) ? subMainData.english : 0.0

      const unitHindi = (subUnitData.hindi && subUnitData.hindi) ? (Number(subUnitData.hindi) / 2).toFixed(1) : 0.0
      const hindi_notes = (subMainData.hindi_notes && subMainData.hindi_notes) ? Number(subMainData.hindi_notes) : 0.0
      const hindi_sub_enrich = (subMainData.hindi_sub_enrich && subMainData.hindi_sub_enrich) ? Number(subMainData.hindi_sub_enrich) : 0.0
      const mainHindi = (subMainData.hindi && subMainData.hindi) ? Number(subMainData.hindi) : 0.0

      const unitMath = (subUnitData.math && subUnitData.math) ? (Number(subUnitData.math) / 2).toFixed(1) : 0.0
      const math_notes = (subMainData.math_notes && subMainData.math_notes) ? Number(subMainData.math_notes) : 0.0
      const math_sub_enrich = (subMainData.math_sub_enrich && subMainData.math_sub_enrich) ? Number(subMainData.math_sub_enrich) : 0.0
      const mainMath = (subMainData.math && subMainData.math) ? Number(subMainData.math) : 0.0

      const unitScience = (subUnitData.science && subUnitData.science) ? (Number(subUnitData.science) / 2).toFixed(1) : 0.0
      const science_notes = (subMainData.science_notes && subMainData.science_notes) ? Number(subMainData.science_notes) : 0.0
      const science_sub_enrich = (subMainData.science_sub_enrich && subMainData.science_sub_enrich) ? Number(subMainData.science_sub_enrich) : 0.0
      const mainScience = (subMainData.science && subMainData.science) ? Number(subMainData.science) : 0.0

      const unitSst = (subUnitData.sst && subUnitData.sst) ? (Number(subUnitData.sst) / 2).toFixed(1) : 0.0
      const sst_notes = (subMainData.sst_notes && subMainData.sst_notes) ? Number(subMainData.sst_notes) : 0.0
      const sst_sub_enrich = (subMainData.sst_sub_enrich && subMainData.sst_sub_enrich) ? Number(subMainData.sst_sub_enrich) : 0.0
      const mainSst = (subMainData.sst && subMainData.sst) ? Number(subMainData.sst) : 0.0



      let hrSumEnglish = Number(unitEnglish) + Number(english_notes) + Number(english_sub_enrich) + Number(mainEnglish)
      let hrSumHindi = Number(unitHindi) + Number(hindi_notes) + Number(hindi_sub_enrich) + Number(mainHindi)
      let hrSumMath = Number(unitMath) + Number(math_notes) + Number(math_sub_enrich) + Number(mainMath)
      let hrSumScience = Number(unitScience) + Number(science_notes) + Number(science_sub_enrich) + Number(mainScience)
      let hrSumSst = Number(unitSst) + Number(sst_notes) + Number(sst_sub_enrich) + Number(mainSst)

      const vrSumUnit = Number(unitEnglish) + Number(unitHindi) + Number(unitMath) + Number(unitScience) + Number(unitSst)
      const vrSumNotes = Number(english_notes) + Number(hindi_notes) + Number(math_notes) + Number(science_notes) + Number(sst_notes)
      const vrSumSubEnrich = Number(english_sub_enrich) + Number(hindi_sub_enrich) + Number(math_sub_enrich) + Number(science_sub_enrich) + Number(sst_sub_enrich)

      const englishGrade = getGrade(hrSumEnglish)
      const hindiGrade = getGrade(hrSumHindi)
      const mathGrade = getGrade(hrSumMath)
      const scienceGrade = getGrade(hrSumScience)
      const sstGrade = getGrade(hrSumSst)

      const compUnit = subUnitData && subUnitData.computer ? subUnitData.computer : 0.0
      const compTheory = subMainData && subMainData.computer ? subMainData.computer : 0.0
      const compPract = subMainData && subMainData.comp_pract ? subMainData.comp_pract : 0.0
      const computerMarks = Number(compTheory) + Number(compPract) + Number(compUnit)

      //result.total= parseFloat(hrSumEnglish+hrSumHindi+hrSumMath+hrSumScience+hrSumSst).toFixed(2)
      return [
        {
          stack: [
            { text: 'B.M. MEMORIAL SCHOOL', font: 'Corben' },
            { text: '(Run under BM Memorial Trust)', style: 'subheaderTrust', font: 'Roboto' },
            { text: 'BARKAGAON, HAZARIBAG', style: 'subheaderAdd' },
            { text: resultExamHeader, style: 'subheaderExam' },
            { text: `Session: ${session}`, style: 'subheaderSession' },
          ],
          style: 'header'
        },
        {
          stack: [
            {
              text: ['REG. NO: ', { text: result.userId, bold: true }],
            },
            {
              text: ['STUDENT NAME: ', { text: result.fullName, bold: true }],
            },
            {
              text: ['CLASS: ', { text: romanClassConvert(selectedClass), bold: true }, { text: '                ROLL NO: ', bold: false }, { text: result.rollNumber, bold: true }],
            },
            {
              text: ['FATHER’S NAME: ', { text: result.fatherName, bold: true }],
            }
          ],
          style: 'stInfo'
        },
        { text: '____________________________________________________________________________________', margin: [0, 0, 0, 2] },
        {
          fontSize: 10,
          table: {
            heights: [25, 25, 28, 28, 28, 28, 28, 28, 30],
            widths: [88, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28],
            //headerRows: 2,
            // keepWithHeaderRows: 1,
            body: [
              [
                { text: 'SUBJECTS', style: 'tableHeader', bold: true, fontSize: 12, alignment: 'center', border: [true, true, true, false], margin: [0, 6, 0, 0] },
                { text: 'Periodic Test', style: 'tableHeader', colSpan: 2, alignment: 'center', margin: [0, 6, 0, 0] },
                {},
                { text: 'Note Book', style: 'tableHeader', colSpan: 2, alignment: 'center', margin: [0, 6, 0, 0] },
                {},
                { text: 'Sub. Enrich', style: 'tableHeader', colSpan: 2, alignment: 'center', margin: [0, 6, 0, 0] },
                {},
                { text: examName.includes('HALF') ? 'Half Yearly Exam' : 'Annual Exam', style: 'tableHeader', colSpan: 2, alignment: 'center', margin: [0, 6, 0, 0] },
                {},
                { text: 'Total', style: 'tableHeader', colSpan: 2, alignment: 'center', margin: [0, 6, 0, 0] },
                {},
                { text: 'Grade', style: 'tableHeader', alignment: 'center', border: [true, true, true, false], margin: [0, 6, 0, 0] },
              ],
              [
                { border: [true, false, true, true], text: '' },
                { text: subColmName, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: 'MO', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: subColmName, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: 'MO', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: subColmName, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: 'MO', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: subColmName, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: 'MO', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: 'MO', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: 'Pcnt%', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { border: [true, false, true, true], text: '' },
              ],
              [
                { text: 'ENGLISH', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: '10.0', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: unitEnglish, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },// Perodic test
                { text: '5.0', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: english_notes, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // note Book test
                { text: '5.0', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: english_sub_enrich, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // sub enrich
                { text: '80.0', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: mainEnglish, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // Exam annual
                { text: hrSumEnglish, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // total horizontal
                { text: parseFloat(hrSumEnglish).toFixed(2), style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // percentage horizontal same as total horizontal
                { text: englishGrade, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // horizontal grade
              ],
              [
                { text: 'HINDI', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: '10.0', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: unitHindi, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },// Peropdic test
                { text: '5.0', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: hindi_notes, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // note Book test
                { text: '5.0', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: hindi_sub_enrich, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // sub enrich
                { text: '80.0', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: mainHindi, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // Exam annual
                { text: hrSumHindi, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // total horizontal
                { text: parseFloat(hrSumHindi).toFixed(2), style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // percentage horizontal same as total horizontal
                { text: hindiGrade, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // horizontal grade
              ],
              [
                { text: 'MATHEMATICS', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: '10.0', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: unitMath, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },// Peropdic test
                { text: '5.0', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: math_notes, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // note Book test
                { text: '5.0', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: math_sub_enrich, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // sub enrich
                { text: '80.0', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: mainMath, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // Exam annual
                { text: hrSumMath, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // total horizontal
                { text: parseFloat(hrSumMath).toFixed(2), style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // percentage horizontal same as total horizontal
                { text: mathGrade, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // horizontal grade
              ],
              [
                { text: 'SCIENCE', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: '10.0', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: unitScience, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },// Peropdic test
                { text: '5.0', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: science_notes, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // note Book test
                { text: '5.0', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: science_sub_enrich, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // sub enrich
                { text: '80.0', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: mainScience, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // Exam annual
                { text: hrSumScience, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // total horizontal
                { text: parseFloat(hrSumScience).toFixed(2), style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // percentage horizontal same as total horizontal
                { text: scienceGrade, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // horizontal grade
              ],
              [
                { text: 'SOC SCIENCE', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: '10.0', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: unitSst, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },// Peropdic test
                { text: '5.0', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: sst_notes, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // note Book test
                { text: '5.0', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: sst_sub_enrich, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // sub enrich
                { text: '80.0', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: mainSst, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // Exam annual
                { text: hrSumSst, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // total horizontal
                { text: parseFloat(hrSumSst).toFixed(2), style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // percentage horizontal same as total horizontal
                { text: sstGrade, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // horizontal grade
              ],
              [
                { text: 'COMPUTER (Additional)', style: 'tableHeader', alignment: 'center' },
                {},
                {},
                {},
                {},
                {},
                {},
                { text: '100.0', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                { text: computerMarks, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // Exam annual
                { text: '***', style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },
                {},
                { border: [true, true, true, false], text: '' },
              ],
              [
                { text: 'TOTAL', style: 'tableHeader', alignment: 'center', bold: true, fontSize: 12, margin: [0, 6, 0, 0] },
                {},
                { text: vrSumUnit, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] },// vertical periodic test addition
                {},
                { text: vrSumNotes, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // vertical note book addtion
                {},
                { text: vrSumSubEnrich, style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // sub Enrich addition
                {},
                {},
                { text: result.total.toFixed(1), style: 'tableHeader', alignment: 'center', margin: [0, 6, 0, 0] }, // Total marks 
                {},
                { border: [true, false, true, true], text: '' },
              ],
            ]
          }
        },
        //table End
        {
          margin: [20, 15, 0, 0],
          stack: [
            {
              text: ['TOTAL MARKS OBTAINED: ', { text: `${result.total}/500        `, bold: true }, { text: '                ATTENDANCE: ', bold: false }, { text: `${attendence}/${result.fullAttendance}`, bold: true }],
            },
          ],
          style: 'marksAttendenceInfo'
        },
        {
          fontSize: 10,
          margin: [0, 5, 0, 0],
          table: {
            widths: [250, 250],
            body: [
              [
                {
                  border: [false, false, false, false],
                  fontSize: 10,
                  table: {
                    widths: [120],
                    body: [
                      [{ type: 'square', ul: ['91 -100    : A1'] }],
                      [{ type: 'square', ul: ['81 - 90     : A2'] }],
                      [{ type: 'square', ul: ['71 - 80     : B1'] }],
                      [{ type: 'square', ul: ['61 - 70     : B2'] }],
                      [{ type: 'square', ul: ['51 - 60     : C1'] }],
                      [{ type: 'square', ul: ['41 - 50     : C2'] }],
                      [{ type: 'square', ul: ['33 - 40     :  D'] }],
                      [{ type: 'square', ul: ['32 & Below E ( Needs to Improvement)'] }],
                    ]
                  }
                },
                {
                  border: [false, false, false, false],
                  fontSize: 11,
                  table: {
                    widths: [100, 80],
                    body: [
                      [{ text: 'Work Education', alignment: 'centre' }, { text: 'Good / Average', alignment: 'centre' }],
                      [{ text: 'Art Education', alignment: 'centre' }, { text: 'Good / Average', alignment: 'centre' }],
                      [{ text: 'Physical Education', alignment: 'centre' }, { text: 'Good / Average', alignment: 'centre' }],
                      [{ text: 'Discipline', alignment: 'centre' }, { text: 'Good / Average', alignment: 'centre' }],
                      [{ text: 'Extra Curricular', alignment: 'centre' }, { text: 'Good / Average', alignment: 'centre' }],
                    ]
                  }
                },

              ]
            ]
          }
        },
        {

          stack: [
            {
              text:
                [
                  'PERCENTAGE: ', { text: `${result.percentage}%        `, bold: true },
                  { text: '            RANK: ', bold: false }, { text: `${result.rank}/${resultList.length}`, bold: true },
                  { text: '                PERFORMANCE: ', bold: false }, { text: result.performance, bold: true }
                ],
            },
          ],
          style: 'marksAttendenceInfo'
        },

        {
          margin: [0, 60, 0, 0],
          stack: [
            {
              text:
                [
                  '          Class Teacher              ',
                  { text: '                        Exam Controller	      ' }, { text: '                         Principal          ' },

                ],
              preserveLeadingSpaces: true
            },
          ],
        },

        {
          canvas: [
            // Draw a rectangle as the border
            {
              type: "rect",
              x: 0,
              y: 0,
              w: 85,
              h: 100,
              r: 2, // Optional: Rounded corners
              lineWidth: 2, // Border thickness
              lineColor: photoBorderColor, // Border color
            },
          ],
          absolutePosition: { x: 460, y: 85 }, // Position of the border
        },
        //student photo
        (result.document && typeof result.document.stPhoto === 'string' && result.document.stPhoto.startsWith('data:image/')) ?
          {
            image: result.document.stPhoto,
            width: 80, // Fit inside the border (slightly smaller than border size)
            height: 95,
            absolutePosition: { x: 463, y: 87 }, // Position image inside the border
          } :
          {
            canvas: [
              {
                type: "rect", // Placeholder rectangle
                x: 0,
                y: 0,
                w: 80,
                h: 95,
                color: "#FFFFFF", // White fill
              },
            ],
            //margin: [-1, -100, 0, 0], // Adjust rectangle to align with the border
            absolutePosition: { x: 463, y: 87 }
          },
      ]
    }),
    defaultStyle: {
      font: 'TimesNewRoman'
    },
    // to make library image
    images: {
      logo: schoolLogo
    },
    styles: {
      header: {
        fontSize: 22,
        bold: false,
        alignment: 'center',
        margin: [0, 5, 0, 0]
      },
      subheaderTrust: {
        fontSize: 10,
        bold: false
      },
      subheaderAdd: {
        fontSize: 10,
        bold: false
      },
      subheaderExam: {
        fontSize: 14,
        decoration: 'underline'
      },
      subheaderSession: {
        fontSize: 12,
        decoration: 'underline'
      },
      logoEstdAndTrust: {
        fontSize: 7,
      },
      stInfo: {
        fontSize: 12,
        alignment: 'left',
        margin: [0, 10, 0, 0]
      },

      tableHeader: {
        //bold: true,
        fontSize: 10,
        color: 'black',
      },
      marksAttendenceInfo: {
        fontSize: 12,
        alignment: 'left',
        margin: [0, 10, 0, 0]
      }
      // superMargin: {
      //   margin: [20, 0, 40, 0],
      //   fontSize: 15
      // }
    }
  };

  pdfMake.createPdf(docDefinition).open();
  //pdfMake.createPdf(docDefinition).download(`Result-report.pdf`) 

}

export const generatePdfInvoice = (data) => {
  let resultList = []
  let selectedClass = '1 A'
  let allStudent = 109
  let session = data && data.session ? data.session : currentSession()


  pdfMake.fonts = {
    // Default font should still be available
    Roboto: {
      normal: 'Roboto-Regular.ttf',
      bold: 'Roboto-Medium.ttf',
      italics: 'Roboto-Italic.ttf',
      bolditalics: 'Roboto-Italic.ttf'
    },
    // Make sure you define all 4 components - normal, bold, italics, bolditalics - (even if they all point to the same font file)
    TimesNewRoman: {
      normal: 'Times-New-Roman-Regular.ttf',
      bold: 'Times-New-Roman-Bold.ttf',
      italics: 'Times-New-Roman-Italics.ttf',
      bolditalics: 'Times-New-Roman-Bold-Italics.ttf'
    },
    Corben: {
      normal: 'Corben-Regular.ttf',
      bold: 'Corben-Bold.ttf',
    }
  }

  var docDefinition = {
    background: function (page) {
      return [
        {
          image: principalSign,
          width: 40,
          height: 40,
          absolutePosition: { x: 460, y: 347 }
        },
        {
          image: examController2,
          width: 60,
          height: 40,
          absolutePosition: { x: 276, y: 347 }
        },
        {
          image: principalSign,
          width: 40,
          height: 40,
          absolutePosition: { x: 460, y: 737 }
        },
        {
          image: examController2,
          width: 60,
          height: 40,
          absolutePosition: { x: 276, y: 737 }
        },
      ];
    },
    content:
      [
        // {
        //   image: 'logo',
        //   width: 50,
        //   height: 50,
        //   absolutePosition: { x: 60, y: 58 }
        // },
        // { text: 'Estd. 2016', style: 'logoEstdAndTrust', absolutePosition: { x: 69, y: 110 }, font:'Roboto' },
        // { text: 'B.M. Memorial Trust: 5815/204', style: 'logoEstdAndTrust', absolutePosition: { x: 40, y: 120 } },

        {
          stack: [
            { text: 'RECIEPT', style: 'subheaderAdd' },
            { text: 'B.M. MEMORIAL SCHOOL', style: 'subheaderExam' },
            //{ text: '(Run under BM Memorial Trust)', style: 'subheaderTrust', font:'Roboto' },
            { text: 'BARKAGAON, HAZARIBAG', style: 'subheaderAdd' },
            //{ text: 'ANNUAL EXAMINATION RESULT', style: 'subheaderExam' },
            { text: `Session: ${session}`, style: 'subheaderSession' },
          ],
          style: 'header'
        },
        {
          stack: [
            {
              text: ['INV. NO: ', { text: data.invoiceId, bold: false }, { text: '                REC. NO.: ', bold: false }, { text: data.receiptNumber, bold: false }],
            },
            {
              text: ['Student Name: ', { text: data.stName, bold: false }, { text: '                                               Class: ', bold: false }, { text: data.class, bold: false }],
            },
            {
              text: ['Date of Payment: ', { text: formatDateddmmyyyy(data.submittedDate), bold: false }],
            }
          ],
          style: 'stInfo'
        },
        { text: '_____________________________________________________________________________________', margin: [0, 0, 0, 2] },
        {
          fontSize: 12,
          table: {
            //heights: 30,
            widths: [30, '*', 52],
            body: [
              [
                { text: 'Sr No.', style: 'tableHeader', alignment: 'center', margin: [0, 0, 0, 0] },

                { text: 'Particulars', style: 'tableHeader', alignment: 'center', margin: [0, 0, 0, 0] },

                { text: 'Amount', style: 'tableHeader', alignment: 'center', margin: [0, 0, 0, 0] },

              ]
            ]
          },
        },
        {
          fontSize: 12,
          table: {
            heights: 400,
            widths: [30, '*', 52],
            body: [
              [
                {
                  stack:
                    [
                      data.detail.map((data, index) => {
                        return {
                          text: `${data.index ? data.index : ' '}`,
                          style: 'tableHeader',
                          alignment: 'center',

                          margin: [0, 0, 0, 0]
                        }
                      })
                    ]
                },
                {
                  stack: [
                    data.detail.map((data, index) => {
                      if (data.particulars) {
                        return {
                          text: `${data.particulars}`,
                          style: 'tableHeader',
                          alignment: 'left',
                          margin: [0, 0, 0, 0]
                        }
                      } else {
                        return {
                          text: `${data.description ? data.description : ' '}`,
                          style: 'tableHeader',
                          alignment: 'left',
                          italics: true,
                          margin: [4, 0, 0, 0]
                        }
                      }
                    })
                  ]
                },
                {
                  stack: [
                    data.detail.map((data, index) => {
                      return {
                        text: `${data.amount ? data.amount : ' '}`,
                        style: 'tableHeader',
                        alignment: 'right',
                        margin: [0, 0, 0, 0]
                      }
                    })
                  ]
                },
              ],
            ]
          },
        },
        {
          fontSize: 12,
          table: {
            //heights: 40,
            widths: [30, '*', 52],
            body: [
              [
                {
                  text: ' ',
                  alignment: 'left', margin: [0, 0, 0, 0], bold: false, fontSize: 14
                },
                {
                  text: 'Total Paid',
                  alignment: 'right', margin: [0, 0, 0, 2], bold: false, fontSize: 14
                },
                {
                  text: `${data.paidAmount}/-`,
                  alignment: 'right', margin: [0, 0, 0, 0], bold: false, fontSize: 14
                },
              ]
            ]
          },
        },
        //table End
        {
          stack: [
            {
              text:
                [
                  'TOTAL MARKS : ', { text: `dfdsf`, bold: true },
                  { text: '                         GRADE: ', bold: false }, { text: 'rtret', bold: true },
                  { text: '                              ATTENDANCE: ', bold: false }, { text: `rt`, bold: true }
                ],
              preserveLeadingSpaces: true
            },
          ],
          style: 'marksAttendenceInfo'
        },
        {

          stack: [
            {
              text:
                [
                  'PERCENTAGE: ', { text: `%`, bold: true },
                  { text: '                  RANK: ', bold: false }, { text: `gdg`, bold: true },
                  { text: '                   PERFORMANCE: ', bold: false }, { text: 'dgdf', bold: true }
                ],
              preserveLeadingSpaces: true
            },
          ],
          style: 'marksAttendenceInfo'
        },
        {
          margin: [0, 40, 0, 0],
          stack: [
            {
              text:
                [
                  '          Class Teacher              ',
                  { text: '                        Exam Controller	      ' },
                  { text: '                            Principal          ' },

                ],
              preserveLeadingSpaces: true
            },
          ],
        },
        { text: '--------------------------------------------------------------------------------------------------------------------------------', margin: [0, 10, 0, 10] },
        {
          image: 'logo',
          width: 50,
          height: 50,
          absolutePosition: { x: 60, y: 445 }
        },
        { text: 'Estd. 2016', style: 'logoEstdAndTrust', absolutePosition: { x: 69, y: 497 }, font: 'Roboto' },
        { text: 'B.M. Memorial Trust: 5815/204', style: 'logoEstdAndTrust', absolutePosition: { x: 40, y: 507 } },

        {
          stack: [
            { text: 'B.M. MEMORIAL SCHOOL', font: 'Corben' },
            { text: '(Run under BM Memorial Trust)', style: 'subheaderTrust', font: 'Roboto' },
            { text: 'BARKAGAON, HAZARIBAG', style: 'subheaderAdd' },
            { text: 'ANNUAL EXAMINATION RESULT', style: 'subheaderExam' },
            { text: `Session: ${session}`, style: 'subheaderSession' },
          ],
          style: 'header'
        },

        { text: '_____________________________________________________________________________________', margin: [0, 0, 0, 2] },


        //table End




        {
          margin: [0, 40, 0, 0],
          stack: [
            {
              text:
                [
                  '          Class Teacher              ',
                  { text: '                        Exam Controller	      ' },
                  { text: '                            Principal          ' },
                ],
              preserveLeadingSpaces: true
            },
          ],
        },

      ],
    defaultStyle: {
      font: 'TimesNewRoman'
    },
    // to make library image
    images: {
      logo: schoolLogo
    },
    styles: {
      header: {
        fontSize: 22,
        bold: false,
        alignment: 'center',
        margin: [0, 5, 0, 0]
      },
      subheaderTrust: {
        fontSize: 10,
        bold: false
      },
      subheaderAdd: {
        fontSize: 10,
        bold: false
      },
      subheaderExam: {
        fontSize: 14,
        decoration: 'underline'
      },
      subheaderSession: {
        fontSize: 12,
        decoration: 'underline'
      },
      logoEstdAndTrust: {
        fontSize: 7,
      },
      stInfo: {
        fontSize: 12,
        alignment: 'left',
        margin: [0, 2, 0, 0]
      },

      tableHeader: {
        //bold: true,
        fontSize: 10,
        color: 'black',
      },
      marksAttendenceInfo: {
        fontSize: 12,
        alignment: 'left',
        margin: [0, 5, 0, 0]
      }
      // superMargin: {
      //   margin: [20, 0, 40, 0],
      //   fontSize: 15
      // }
    }
  };

  pdfMake.createPdf(docDefinition).open();

}

export const generateGSTInvoice = (data) => {
  let resultList = []
  let selectedClass = '1 A'
  let allStudent = 109
  let session = data && data.session ? data.session : currentSession()

  pdfMake.fonts = {
    // Default font should still be available
    Roboto: {
      normal: 'Roboto-Regular.ttf',
      bold: 'Roboto-Medium.ttf',
      italics: 'Roboto-Italic.ttf',
      bolditalics: 'Roboto-Italic.ttf'
    },
    // Make sure you define all 4 components - normal, bold, italics, bolditalics - (even if they all point to the same font file)
    TimesNewRoman: {
      normal: 'Times-New-Roman-Regular.ttf',
      bold: 'Times-New-Roman-Bold.ttf',
      italics: 'Times-New-Roman-Italics.ttf',
      bolditalics: 'Times-New-Roman-Bold-Italics.ttf'
    },
    Corben: {
      normal: 'Corben-Regular.ttf',
      bold: 'Corben-Bold.ttf',
    }
  }

  var docDefinition = {
    // background: function (page) {
    //     return [
    //       {
    //         image: principalSign,
    //         width: 40,
    //         height: 40,
    //         absolutePosition: { x: 460, y: 347 }
    //       },
    //       {
    //         image: examController2,
    //         width: 60,
    //         height: 40,
    //         absolutePosition: { x: 276, y: 347 }
    //       },
    //       {
    //         image: principalSign,
    //         width: 40,
    //         height: 40,
    //         absolutePosition: { x: 460, y: 737 }
    //       },
    //       {
    //         image: examController2,
    //         width: 60,
    //         height: 40,
    //         absolutePosition: { x: 276, y: 737 }
    //       },
    //     ];
    // },
    content:
      [
        {
          stack: [
            { text: 'Bill of Supply', style: 'subheaderAdd' },
          ],
          style: 'header'
        },

        {
          //style: 'tableExample',
          //color: '#444',
          fontSize: 9,
          table: {
            widths: ['50%', 122, 122],
            //headerRows: 2,
            // keepWithHeaderRows: 1,
            body: [
              [
                {
                  rowSpan: 3,
                  stack: [
                    { text: 'SHAHI TRADERS', alignment: 'left', bold: true, margin: [0, 0, 0, 0] },
                    { text: 'NA, Narkatia Bazar, Narkatia', alignment: 'left', margin: [0, 0, 0, 0] },
                    { text: 'Purbi Champaran-845301', alignment: 'left', margin: [0, 0, 0, 0] },
                    { text: 'GSTIN/UIN    : 10BDYPP4726l1z0', alignment: 'left', margin: [0, 0, 0, 0] },
                    { text: 'State Name   : Bihar, Code  :  10', alignment: 'left', margin: [0, 0, 0, 0] }
                  ]

                },
                {
                  stack: [
                    { text: 'Invoice No', alignment: 'left', margin: [0, 0, 0, 0] },
                    { text: '10', alignment: 'left', margin: [0, 0, 0, 0], bold: true },
                  ]
                },
                {
                  stack: [
                    { text: 'Dated', alignment: 'left', margin: [0, 0, 0, 0] },
                    { text: '27-Jan-2023', alignment: 'left', margin: [0, 0, 0, 0], bold: true },
                  ]
                }
              ],
              ['',
                {
                  stack: [
                    { text: 'Delivery Note', alignment: 'left', margin: [0, 0, 0, 0] },
                    { text: ' ', alignment: 'left', margin: [0, 0, 0, 0], bold: true },
                  ]
                },
                {
                  stack: [
                    { text: 'Mode/Terms of Payment', alignment: 'left', margin: [0, 0, 0, 0] },
                    { text: ' ', alignment: 'left', margin: [0, 0, 0, 0], bold: true },
                  ]
                }
              ],
              ['',
                {
                  stack: [
                    { text: 'Supplier\'s Ref.', alignment: 'left', margin: [0, 0, 0, 0] },
                    { text: ' ', alignment: 'left', margin: [0, 0, 0, 0], bold: true },
                  ]
                },
                {
                  stack: [
                    { text: 'Other Reference(s)', alignment: 'left', margin: [0, 0, 0, 0] },
                    { text: ' ', alignment: 'left', margin: [0, 0, 0, 0], bold: true },
                  ]
                }
              ],
              [
                {
                  rowSpan: 5,
                  stack: [
                    { text: 'Buyer', alignment: 'left', margin: [0, 0, 0, 0] },
                    { text: 'GANPATI ENTERPRISES', alignment: 'left', bold: true, margin: [0, 0, 0, 0] },
                    { text: 'Address', alignment: 'left', margin: [0, 0, 0, 0] },
                    { text: 'GSTIN/UIN    : 1ACD141432536GTR', alignment: 'left', margin: [0, 0, 0, 0] },
                    { text: 'State Name   : Bihar, Code  :  10', alignment: 'left', margin: [0, 0, 0, 0] }
                  ]

                },
                {
                  stack: [
                    { text: 'Buyer\'s Order No.', alignment: 'left', margin: [0, 0, 0, 0] },
                    { text: ' ', alignment: 'left', margin: [0, 0, 0, 0], bold: true },
                  ]
                },
                {
                  stack: [
                    { text: 'Dated', alignment: 'left', margin: [0, 0, 0, 0] },
                    { text: ' ', alignment: 'left', margin: [0, 0, 0, 0], bold: true },
                  ]
                }
              ],
              ['',
                {
                  stack: [
                    { text: 'Dispatch Document No.', alignment: 'left', margin: [0, 0, 0, 0] },
                    { text: ' ', alignment: 'left', margin: [0, 0, 0, 0], bold: true },
                  ]
                },
                {
                  stack: [
                    { text: 'Delivery Note Date', alignment: 'left', margin: [0, 0, 0, 0] },
                    { text: ' ', alignment: 'left', margin: [0, 0, 0, 0], bold: true },
                  ]
                }
              ],
              ['',
                {
                  stack: [
                    { text: 'Dispatch Through', alignment: 'left', margin: [0, 0, 0, 0] },
                    { text: ' ', alignment: 'left', margin: [0, 0, 0, 0], bold: true },
                  ]
                },
                {
                  stack: [
                    { text: 'Destination', alignment: 'left', margin: [0, 0, 0, 0] },
                    { text: 'ADAPUR ', alignment: 'left', margin: [0, 0, 0, 0], bold: true },
                  ]
                }
              ],
              ['',
                {
                  stack: [
                    { text: 'Bill of Landing/LR-RR No.', alignment: 'left', margin: [0, 0, 0, 0] },
                    { text: ' ', alignment: 'left', margin: [0, 0, 0, 0], bold: true },
                  ]
                },
                {
                  stack: [
                    { text: 'Motor Vehicle No.', alignment: 'left', margin: [0, 0, 0, 0] },
                    { text: 'UP53CT-0807 ', alignment: 'left', margin: [0, 0, 0, 0], bold: true },
                  ]
                }
              ],
              ['', { colSpan: 2, text: 'Terms of Delivery\n  \n\n\n' }],
              //['Sample value 1', '', ''],
            ]
          }
        },
        {
          fontSize: 12,
          table: {
            //heights: 30,
            widths: [12, 225, 46, 60, 30, 25, 54],
            body: [
              [
                { text: 'Sl\nNo', style: 'tableHeader', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 8 },
                { text: 'Description of Goods', style: 'tableHeader', alignment: 'center', margin: [0, 0, 0, 0] },
                { text: 'HSN/SAC', style: 'tableHeader', alignment: 'center', margin: [0, 0, 0, 0] },
                { text: 'Quantity', style: 'tableHeader', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 10 },
                { text: 'Rate.', style: 'tableHeader', alignment: 'center', margin: [0, 0, 0, 0] },
                { text: 'Per', style: 'tableHeader', alignment: 'center', margin: [0, 0, 0, 0] },
                { text: 'Amount', style: 'tableHeader', alignment: 'center', margin: [0, 0, 0, 0] },

              ]
            ]
          },
        },
        {
          fontSize: 12,
          table: {
            heights: 250,
            widths: [12, 225, 46, 60, 30, 25, 54],
            body: [
              [
                {
                  stack:
                    [
                      data.detail.map((data, index) => {
                        return {
                          text: `${data.index ? data.index : ' '}`,
                          style: 'tableHeader',
                          alignment: 'center',
                          margin: [0, 0, 0, 0]
                        }
                      })
                    ]
                },
                {
                  stack: [
                    data.detail.map((data, index) => {
                      if (data.particulars) {
                        return {
                          text: `${data.particulars}`,
                          style: 'tableHeader',
                          alignment: 'left',
                          margin: [0, 0, 0, 0]
                        }
                      } else {
                        return {
                          text: `${data.description ? data.description : ' '}`,
                          style: 'tableHeader',
                          alignment: 'left',
                          italics: true,
                          margin: [4, 0, 0, 0]
                        }
                      }
                    })
                  ]
                },
                {
                  stack: [
                    data.detail.map((data, index) => {
                      return {
                        text: `${data.hsn ? data.hsn : ' '}`,
                        style: 'tableHeader',
                        alignment: 'right',
                        margin: [0, 0, 0, 0]
                      }
                    })
                  ]
                },
                {
                  stack: [
                    data.detail.map((data, index) => {
                      return {
                        text: `${data.qty ? data.qty : ' '}`,
                        style: 'tableHeader',
                        alignment: 'right',
                        margin: [0, 0, 0, 0]
                      }
                    })
                  ]
                },
                {
                  stack: [
                    data.detail.map((data, index) => {
                      return {
                        text: `${data.rate ? data.rate : ' '}`,
                        style: 'tableHeader',
                        alignment: 'right',
                        margin: [0, 0, 0, 0]
                      }
                    })
                  ]
                },
                {
                  stack: [
                    data.detail.map((data, index) => {
                      return {
                        text: `${data.per ? data.per : ' '}`,
                        style: 'tableHeader',
                        alignment: 'right',
                        margin: [0, 0, 0, 0]
                      }
                    })
                  ]
                },
                {
                  stack: [
                    data.detail.map((data, index) => {
                      return {
                        text: `${data.amount ? data.amount : ' '}`,
                        style: 'tableHeader',
                        alignment: 'right',
                        margin: [0, 0, 0, 0]
                      }
                    })
                  ]
                },
              ],
            ]
          },
        },
        {
          fontSize: 9,
          table: {
            //heights: 40,
            widths: [12, 225, 46, 60, 30, 25, 54],
            body: [
              [
                {
                  text: ' ',
                  alignment: 'left', margin: [0, 0, 0, 0], bold: false
                },
                {
                  text: 'Total',
                  alignment: 'right', margin: [0, 0, 0, 2], bold: false
                },
                {
                  text: ' ',
                  alignment: 'left', margin: [0, 0, 0, 0], bold: false
                },
                {
                  text: `${data.qty ? data.qty : 3250}`,
                  alignment: 'center', margin: [0, 0, 0, 0], bold: false
                },
                {
                  text: ' ',
                  alignment: 'left', margin: [0, 0, 0, 0], bold: false
                },
                {
                  text: ' ',
                  alignment: 'left', margin: [0, 0, 0, 0], bold: false
                },
                {
                  //colSpan: 2,
                  text: `${data.paidAmount}`,
                  alignment: 'right', margin: [0, 0, 0, 0], bold: false
                },
              ],
              [
                {
                  border: [true, true, false, false],
                  colSpan: 5,
                  text: 'Amount chargeable (in words)'
                },
                {},
                {},
                {},
                {},
                {
                  border: [false, true, true, false],
                  colSpan: 2,
                  alignment: 'right',
                  text: 'E & O E',
                  italics: true
                },
              ],
              [
                {        //left, up, right, bottom
                  border: [true, false, true, true],
                  colSpan: 7,
                  text: 'INR Five Lakh Eighty Thousands Seven Hundread Eighty Five Only',
                  bold: true
                },
                {},
                {},
                {},
                {},
                {},
                {}
              ],
              [
                {
                  colSpan: 6,
                  alignment: 'center',
                  text: 'HSN/SAC'
                },
                {},
                {},
                {},
                {},
                {},
                {
                  alignment: 'center',
                  text: 'Taxable\nValue',
                  //italics:true
                },
              ],
              [
                {
                  colSpan: 6,
                  //alignment: 'center',
                  text: '1006'
                },
                {},
                {},
                {},
                {},
                {},
                {
                  alignment: 'center',
                  text: '580,454.00',
                  //italics:true
                },
              ],
              [
                {
                  colSpan: 6,
                  alignment: 'right',
                  text: 'Total',
                  bold: true
                },
                {},
                {},
                {},
                {},
                {},
                {
                  alignment: 'center',
                  text: '580,454.00',
                  bold: true
                },
              ],
              [
                {
                  border: [true, true, true, false],
                  colSpan: 7,
                  rowSpan: 4,
                  text: ['Tax Amount (In words)  :', { text: 'NILL', bold: true }]
                },
                '',
                '',
                '',
                '',
                '',
                ''
              ],
              [
                '',
                '',
                '',
                '',
                '',
                '',
                ''
              ],
              [
                '',
                '',
                '',
                '',
                '',
                '',
                ''
              ],
              [
                '',
                '',
                '',
                '',
                '',
                '',
                ''
              ],
              [
                {         //left, up, right, bottom
                  border: [true, false, false, false],
                  colSpan: 2,
                  text: ' '
                },
                {},
                {         //left, up, right, bottom
                  border: [false, false, true, true],
                  colSpan: 5,

                  stack: [
                    {
                      text: ['Company\'s Bank Details '],
                    },
                    {
                      text: ['Bank Name                  : ', { text: 'ICICI BANK', bold: true }],
                    },
                    {
                      text: ['A/c No.                         : ', { text: '162678935434', bold: true }]
                    },
                    {
                      text: ['Branch & IFSC Code  : ', { text: 'RAXAUL & ICICI000564', bold: true }],
                    }
                  ],
                },
                {},
                {},
                {},
                {}
              ],
              [
                {         //left, up, right, bottom
                  border: [true, false, true, true],
                  colSpan: 2,
                  stack: [
                    {
                      text: 'Declaration',
                      bold: true,
                      decoration: 'underline'
                    },
                    {
                      text: 'We declare that Invoice shows the actual price of the goods described and that all particulars are true and correct.'
                    }
                  ]
                },
                {},
                {         //left, up, right, bottom
                  border: [true, true, true, true],
                  colSpan: 5,

                  stack: [
                    {
                      text: 'for SHAHI TRADERS',
                      bold: true,
                      alignment: 'right',
                    },
                    {
                      text: ' ',
                    },
                    {
                      text: ' '
                    },
                    {
                      text: 'Authorised Signatory',
                      alignment: 'right',
                    }
                  ],
                },
                {},
                {},
                {},
                {}
              ],
            ]
          },
        },
        // {
        //   canvas: [
        //       {
        //         type: 'rect',
        //         x: 0,
        //         y: 0,
        //         w: 0,
        //         h: 10,
        //         //r: 5,
        //         //dash: { length: 5 },
        //         // lineWidth: 10,
        //         lineColor: 'blue',
        //       },
        //     ]
        // },
        //table End
        {
          text: 'This is a computer generated invoice.',
          //bold: true
          fontSize: 9,
          alignment: 'center'
        },

      ],
    defaultStyle: {
      font: 'TimesNewRoman'
    },
    // to make library image
    images: {
      logo: schoolLogo
    },
    styles: {
      header: {
        fontSize: 22,
        bold: false,
        alignment: 'center',
        margin: [0, 5, 0, 0]
      },
      subheaderTrust: {
        fontSize: 10,
        bold: false
      },
      subheaderAdd: {
        fontSize: 10,
        bold: false
      },
      subheaderExam: {
        fontSize: 14,
        decoration: 'underline'
      },
      subheaderSession: {
        fontSize: 12,
        decoration: 'underline'
      },
      logoEstdAndTrust: {
        fontSize: 7,
      },
      stInfo: {
        fontSize: 12,
        alignment: 'left',
        margin: [0, 2, 0, 0]
      },

      tableHeader: {
        //bold: true,
        fontSize: 10,
        color: 'black',
      },
      marksAttendenceInfo: {
        fontSize: 12,
        alignment: 'left',
        margin: [0, 5, 0, 0]
      }
      // superMargin: {
      //   margin: [20, 0, 40, 0],
      //   fontSize: 15
      // }
    }
  };

  pdfMake.createPdf(docDefinition).open();

}

const vfsFonts = require('pdfmake/build/vfs_fonts');

pdfMake.vfs = vfsFonts.pdfMake.vfs;

export const generateInvoice2 = (invoiceDetail, isPrint = false) => {
  const itemFullName = (itemName) => {
    const newItemName = otherPaymentTypeList.find(data => data.value === itemName)
    return ((newItemName && newItemName.label) || itemName)
  }

  const createInvoiceContent = (invoiceDetail, isCopy = false) => ({
    stack: [
      { text: 'INVOICE', style: 'header' },
      {
        columns: [
          [
            { text: 'B.M. Memorial School', style: 'subheader' },
            { text: '(Run under BM Memorial Trust)', style: 'subheaderTrust', font: 'Roboto' },
            { text: 'BARKAGAON, HAZARIBAG' },
            { text: 'Phone: 9955410000', bold: true, fontSize: 11 },
          ],
          [
            {
              text: `Date: ${formatDateddmmyyyy(invoiceDetail.submittedDate)}`,
              alignment: 'right',
              bold: true, fontSize: 11
            },
            {
              text: `Invoice: ${invoiceDetail.invoiceId}`,
              alignment: 'right',
              bold: true, fontSize: 11
            },
            {
              text: `Recpt. No.: ${invoiceDetail.receiptNumber ? invoiceDetail.receiptNumber : 'N/A'}`,
              alignment: 'right'
            }
          ]
        ]
      },
      { text: ' ', margin: [0, 10, 0, 0] },
      { text: 'Bill To:', style: 'subheader' },
      {
        columns: [
          [
            { text: `Student Name: ${invoiceDetail.stName}` },
            { text: `Student ID: ${invoiceDetail.regId}` },
            { text: `Class: ${invoiceDetail.class}` },
            { text: `Session: (${invoiceDetail.session})` },
          ],
          []
        ]
      },
      { text: ' ', margin: [0, 10, 0, 0] },
      {
        style: 'tableExample',
        table: {
          widths: ['*', 70],
          body: [
            ['Description', 'Amount'],
            ...invoiceDetail.feeDetails.map(item => [
              item.existMonthfee ? `Tuition Fee : ${item.name}`
                : item.existBusFee ? `Transport Fee : ${item.name}`
                  : itemFullName(item.name),
              { text: `${Number(item.amount).toFixed(2)}/-`, alignment: 'right' }
            ]),
            [{ text: 'Concession' }, { text: `${Number(invoiceDetail.concession).toFixed(2)}/-`, alignment: 'right' }],
            [{ text: 'Excess Amount' }, { text: `${Number(invoiceDetail.excessAmount).toFixed(2)}/-`, alignment: 'right' }],
            [{ text: 'Over Excess Amount' }, { text: `${Number(invoiceDetail.preExcessAmount).toFixed(2)}/-`, alignment: 'right' }],
            [{ text: 'Over Due Amount' }, { text: `${Number(invoiceDetail.preDueAmount).toFixed(2)}/-`, alignment: 'right' }],
            [{ text: 'Late Fee Amount' }, { text: `${Number(invoiceDetail.fineAmount).toFixed(2)}/-`, alignment: 'right' }],

            [{ text: 'Total', alignment: 'right' }, { text: `${invoiceDetail.totalGrandAmount.toFixed(2)}/-`, alignment: 'right' }],
            [{ text: 'Total Due', alignment: 'right' }, { text: `${Number(invoiceDetail.dueAmount).toFixed(2)}/-`, alignment: 'right' }],
            [{ text: 'Total Paid Amount', alignment: 'right', bold: true, fontSize: 10 }, { text: `${Number(invoiceDetail.paidAmount).toFixed(2)}/-`, alignment: 'right', bold: true, fontSize: 10 }]
          ]
        }
      },
      { text: ' ', margin: [0, 20, 0, 0] },
      {
        columns: [
          [
            { text: isCopy ? 'Copy of Invoice' : 'Original Invoice', style: 'footer' }
          ],
          [
            { text: 'Signature', style: 'footer', alignment: 'right' }
          ]
        ]
      }

    ],
    margin: [20, 20, 20, 20] // Adjust margin to fit within half page
  });

  const docDefinition = {
    pageSize: 'A4',
    pageOrientation: 'landscape',
    pageMargins: [20, 20, 20, 20], // Adjust page margins as needed
    content: [
      {
        columns: [
          {
            width: '50%',
            stack: createInvoiceContent(invoiceDetail, true).stack,
            margin: [20, 10, 20, 0]
            //[left, up, right, down]
          },
          {
            //width: '10%',
            stack: [
              {
                canvas: [
                  {
                    type: 'line',
                    x1: 5,
                    y1: 0,
                    x2: 5,
                    y2: 555,
                    lineWidth: 1,
                    dash: { length: 5, space: 5 }
                  }
                ],
                //margin: [10, 0, 10, 0]
              },
            ]
          },
          {
            width: '50%',
            stack: createInvoiceContent(invoiceDetail, false).stack,
            margin: [20, 10, 20, 0]
          }
        ],
        columnGap: 20
      },
      // {
      //     canvas: [
      //         {
      //             type: 'line',
      //             x1: 297.5,
      //             y1: 0,
      //             x2: 297.5,
      //             y2: 595.5,
      //             lineWidth: 1,
      //             dash: { length: 5, space: 5 }
      //         }
      //     ]
      // }
    ],
    styles: {
      header: {
        fontSize: 18,
        bold: true
      },
      subheader: {
        fontSize: 14,
        bold: true
      },
      footer: {
        fontSize: 12,
        italics: true
      },
      tableExample: {
        margin: [0, 5, 0, 15]
      }
    },
    defaultStyle: {
      fontSize: 10 // Adjust font size to fit content better in half page
    }
  };

  if (isPrint) {
    pdfMake.createPdf(docDefinition).print();
  } else {
    pdfMake.createPdf(docDefinition).open();
  }

};

export const generateInvoice = (invoiceDetail, isPrint = false) => {
  const itemFullName = (itemName) => {
    const newItemName = otherPaymentTypeList.find(data => data.value === itemName);
    return (newItemName?.label || itemName);
  };

  pdfMake.fonts = {
    // Default font should still be available
    Roboto: {
      normal: 'Roboto-Regular.ttf',
      bold: 'Roboto-Medium.ttf',
      italics: 'Roboto-Italic.ttf',
      bolditalics: 'Roboto-Italic.ttf'
    },
    // Make sure you define all 4 components - normal, bold, italics, bolditalics - (even if they all point to the same font file)
    TimesNewRoman: {
      normal: 'Times-New-Roman-Regular.ttf',
      bold: 'Times-New-Roman-Bold.ttf',
      italics: 'Times-New-Roman-Italics.ttf',
      bolditalics: 'Times-New-Roman-Bold-Italics.ttf'
    },
    Corben: {
      normal: 'Corben-Regular.ttf',
      bold: 'Corben-Bold.ttf',
    },
    Devanagari: {
      normal: 'NotoSansDevanagari-Regular.ttf',
      // bold: 'NotoSansDevanagari-Regular.ttf',
    }
  }

  const createInvoiceBlock = (detail, isCopy = false) => ({
    stack: [
      { text: 'B.M. Memorial School', style: 'header', alignment: "center" },
      { text: 'Receipt', style: 'subheader', alignment: "center", fontSize: 10, italics: true },
      {
        columns: [
          [
            { text: `BARKAGAON, HAZARIBAG`, bold: true, fontSize: 10 },
            // { text: '(Run under BM Memorial Trust)', style: 'subheaderTrust', font: 'Roboto' },
            { text: 'Phone: 9470510100, 9431354001', bold: true, fontSize: 11 },
          ],
          [
            { text: `Date: ${formatDateddmmyyyy(detail.submittedDate)}`, alignment: 'right', bold: true, fontSize: 10 },
            { text: `Invoice: ${detail.invoiceId}`, alignment: 'right', bold: true, fontSize: 10 },
            { text: `Recpt. No.: ${detail.receiptNumber || 'N/A'}`, alignment: 'right' },
            //{ text: `Session: ${detail.session || 'N/A'}`, alignment: 'right' }
          ],
        ],
      },
      //{ text: `BARKAGAON, Phone: 9955410000`, bold: true, fontSize: 10 },
      // { text: ' ', margin: [0, 0] },
      {
        columns: [
          [{ text: 'Bill To:', style: 'subheaderTrust' }],
          [{ text: `Pg. No.:${detail.pgNumber || ' '}`, alignment: 'right' }],
        ]
      },
      {
        columns: [
          [
            { text: `Student Name: ${detail.stName}` },
            { text: `Student ID: ${detail.regId}    Class: ${detail.class}    Session: (${detail.session})` },
            //{ text: `Student ID: ${detail.regId}  ` },
            //{ text: `Class: ${detail.class}` },
            //{ text: `Session: (${detail.session})` },
          ],
        ]
      },
      // { text: ' ', margin: [0, -2] },
      {
        style: 'tableExample',
        table: {
          widths: ['*', 70],
          body: [
            ['Description', 'Amount'],
            ...detail.feeDetails.map(item => [
              item.existMonthfee ? `Tuition Fee : ${item.name}`
                : item.existBusFee ? `Transport Fee : ${item.name}`
                  : itemFullName(item.name),
              { text: `${Number(item.amount).toFixed(2)}/-`, alignment: 'right' }
            ]),
            [{ text: 'Concession' }, { text: `${Number(detail.concession).toFixed(2)}/-`, alignment: 'right' }],
            [{ text: 'Excess Amount' }, { text: `${Number(detail.excessAmount).toFixed(2)}/-`, alignment: 'right' }],
            [{ text: 'Over Excess Amount' }, { text: `${Number(detail.preExcessAmount).toFixed(2)}/-`, alignment: 'right' }],
            [{ text: 'Over Due Amount' }, { text: `${Number(detail.preDueAmount).toFixed(2)}/-`, alignment: 'right' }],
            [{ text: 'Late Fee Amount' }, { text: `${Number(detail.fineAmount).toFixed(2)}/-`, alignment: 'right' }],
            [{ text: 'Total', alignment: 'right' }, { text: `${detail.totalGrandAmount.toFixed(2)}/-`, alignment: 'right' }],
            [{ text: 'Total Due', alignment: 'right' }, { text: `${Number(detail.dueAmount).toFixed(2)}/-`, alignment: 'right' }],
            [{ text: 'Total Paid Amount', alignment: 'right', bold: true, fontSize: 10 }, { text: `${Number(detail.paidAmount).toFixed(2)}/-`, alignment: 'right', bold: true, fontSize: 10 }]
          ]
        }
      },
      // { text: ' ', margin: [0, 5] },
      {
        columns: [
          [{ text: `Time: ${utcToIST(detail.createdDate, true, true)}`, style: 'footer', italics: true, fontSize: 8 }],
          [{ text: ' ', style: 'footer', alignment: 'right', fontSize: 8 }]
        ]
      },
      // {
      //   columns: [
      //     [{ text: ''+ detail.invoiceId, style: 'footer', italics: true }],
      //     [{ text: ' ', style: 'footer', alignment: 'right' }]
      //   ]
      // },
      {
        columns: [
          [{ text: isCopy ? `Copy of Invoice(${detail.invoiceId})` : `Original Invoice(${detail.invoiceId})`, style: 'footer', bold: !isCopy ? true : false }],
          [{ text: 'Signature_____________.  ', style: 'footer', alignment: 'right' }]
        ]
      },
      {
        text: "*** पेड़ लगायें पर्यावरण बचायें ***",
        font: "Devanagari",
        alignment: "center",
        // bold: true,
        // margin: [0, 0, 0, 5]
      }
      // {text: '**** पेड़ लगायें पर्यावरण बचाएं ******}
    ],

    // margin: [10, 10, 10, 10]
  });

  const docDefinition = {
    pageSize: 'A4',
    pageOrientation: 'portrait',
    pageMargins: [10, 10, 10, 10],
    content: [
      // Top row: two filled blocks with more gap and vertical dashed line
      {
        columns: [
          { width: '47%', stack: createInvoiceBlock(invoiceDetail, false).stack },
          {
            width: '6%', // bigger gap for dashed line
            stack: [
              {
                canvas: [
                  { type: 'line', x1: 20, y1: 0, x2: 20, y2: 300, lineWidth: 1, dash: { length: 5, space: 5 } }
                ]
              }
            ]
          },
          { width: '47%', stack: createInvoiceBlock(invoiceDetail, true).stack }
        ],
        columnGap: 10
      },


      // { text: ' ', margin: [0, 20] },

      // // Bottom row: blank blocks
      // {
      //   columns: [
      //     { width: '50%', stack: [] },
      //     { width: '50%', stack: [] }
      //   ],
      //   columnGap: 10
      // },

      // // Horizontal dashed line between top and bottom rows
      // {
      //   canvas: [
      //     { type: 'line', x1: 10, y1: 0, x2: 585, y2: 0, lineWidth: 1, dash: { length: 5, space: 5 } }
      //   ],
      //   margin: [0, 10]
      // }
    ],
    styles: {
      header: { fontSize: 16, bold: true },
      subheader: { fontSize: 14, bold: true },
      subheaderTrust: { fontSize: 11, italics: true },
      footer: { fontSize: 10, italics: true },
      tableExample: { margin: [0, 5, 0, 15] }
    },
    defaultStyle: { fontSize: 9 }
  };

  if (isPrint) {
    pdfMake.createPdf(docDefinition).print();
  } else {
    pdfMake.createPdf(docDefinition).open();
  }
};





export const exportInvoicePDF = (allInvoice, options = { as: "pdf", scale: 1.5 }, fromDate, toDate, userId, payOptionList = []) => {

  const todayStr = formatTodayDate()
  const title = `Invoices (${todayStr})`;
  const filename = `Invoices_${todayStr}`;
  const formDateStr = new Date(fromDate).toLocaleDateString("en-GB")
  const toDateObj = toDate ? new Date(toDate) : new Date()
  const toDateStr = toDateObj.toLocaleDateString("en-GB")
  const start = new Date(fromDate);
  const end = toDateObj;

  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);

  const msInDay = 1000 * 60 * 60 * 24;
  const dayCount = Math.floor((end - start) / msInDay) + 1;

  const dateRangeStr = userId ? `BMMS ID : ${userId}` : `From: ${formDateStr}   To: ${toDateStr}, Total Days: ${dayCount}`;

  // Generate Payment Mode Legend text above the table
  let legendText = "";
  if (Array.isArray(payOptionList) && payOptionList.length > 0) {
    const legendParts = payOptionList.map(opt => {
      const modeId = opt.payModeId || opt._id;
      const label = formatPayOptionLabel(opt);
      return `${modeId} = ${label}`;
    });
    legendText = `* Payment Legend: C = Cash | ${legendParts.join(' | ')}`;
  } else {
    legendText = `* Payment Legend: C = Cash | O = Online`;
  }

  const getShorthandCO = (inv, payOptions) => {
    const paymentList = inv?.invoiceInfo?.payment || [];
    if (!Array.isArray(paymentList) || paymentList.length === 0) {
      const mode = inv?.invoiceInfo?.paymentMode || 'Cash';
      return mode === 'Cash' ? `C=${inv?.amount || 0}` : `O=${inv?.amount || 0}`;
    }
    const parts = paymentList.map(p => {
      if (p.payModeId === 'Cash') {
        return `C=${p.amount || 0}`;
      }
      const matched = (payOptions || []).find(opt => opt.payModeId === p.payModeId || opt._id === p.payModeId);
      const code = matched?.payModeId || (p.payModeId && p.payModeId.length <= 10 ? p.payModeId : 'Online');
      return `O=${p.amount || 0} (${code})`;
    });
    return parts.join(', ');
  };

  const headers = [
    "R.No.",
    "Submitted Date",
    "Entry Date",
    "Recpt No.",
    "Invoice ID",
    "Student Name",
    "BMMS ID",
    "Class",
    "Session",
    "Amount C/O",
    "Amount",
    "Reciever Name",
  ];

  // Prepare rows
  const data = allInvoice.map((data, index) => {
    const row = [
      (index + 1).toString(), // R.No. (as string)
      data?.invoiceInfo?.submittedDate ? new Date(data.invoiceInfo.submittedDate).toLocaleDateString("en-GB") : "",
      data?.created ? new Date(data.created).toLocaleDateString("en-GB") : "",
      data?.invoiceInfo?.receiptNumber || "-",
      data.invoiceId,
      data?.invoiceInfo?.userData?.userInfo?.fullName || "",
      data?.invoiceInfo?.userData?.userInfo?.userId || "",
      data?.invoiceInfo?.userData?.userInfo?.class || "",
      data.session || "",
      getShorthandCO(data, payOptionList),
      { text: (data?.amount || 0).toString(), alignment: "right" },
      data?.invoiceInfo?.recieverName || "",
    ];


    // If deleted, apply strikethrough style
    if (data?.deleted) {
      return row.map((cell) =>
        typeof cell === "object"
          ? { ...cell, decoration: "lineThrough", color: "red" } // keep right alignment for Amount
          : { text: cell?.toString(), decoration: "lineThrough", color: "red" }
      );
    }
    return row;
  });

  // Table body
  const body = [
    headers.map((h) => ({
      text: h,
      bold: true,
      fillColor: "#eeeeee",
      alignment: "center",
    })),
    ...data,
  ];

  const docDefinition = {
    content: [
      {
        text: title,
        style: "header",
        alignment: "center",
        colSpan: headers.length,
      },
      { text: "\n" }, // spacing
      { text: dateRangeStr, margin: [0, 0, 0, 4], italics: true },
      ...(legendText ? [{ text: legendText, margin: [0, 0, 0, 8], fontSize: 10, color: "#444444" }] : []),
      {
        style: "tableExample",
        table: {
          headerRows: 1,
          // custom column widths
          widths: [
            25,    // R.No. small
            "auto", // Submitted Date
            "auto", // Entry Date
            "auto", // Recpt No.
            "auto", // Invoice ID
            95,    // Student Name
            "auto", // BMMS ID
            "auto", // Class
            "auto", // Session
            90,    // Amount C/O shorthand
            "auto", // Amount
            90     // Reciever Name
          ],
          body: body,
        },
        layout: {
          fillColor: function (rowIndex) {
            return rowIndex % 2 === 0 ? null : "#f9f9f9"; // zebra striping
          },
        },
      },
    ],
    styles: {
      header: { fontSize: 16, bold: true, margin: [0, 0, 0, 10] },
      tableExample: { margin: [0, 5, 0, 15] },
    },
    defaultStyle: {
      fontSize: 14,
    },
    pageOrientation: "landscape", // better fit for wide table
  };

  // Download PDF
  //pdfMake.createPdf(docDefinition).download(`${filename}.pdf`);
  return new Promise((resolve, reject) => {
    pdfMake.createPdf(docDefinition).getBlob(async (blob) => {
      try {
        if (options.as === "pdf") {
          // Normal vector PDF download
          pdfMake.createPdf(docDefinition).download(`${filename}.pdf`);
          resolve("downloaded-pdf");
        } else if (options.as === "images") {
          // Return array of images
          const images = await convertPdfToImages(blob, options.scale);
          resolve(images);
        } else if (options.as === "image-pdf") {
          // Convert to images, then embed into new PDF
          const images = await convertPdfToImages(blob, options.scale);
          const imageDoc = {
            content: images.map((img, idx) => ({
              image: img,
              width: 500,
              pageBreak: idx === images.length - 1 ? null : "after",
            })),
          };
          pdfMake.createPdf(imageDoc).download(`${filename}.pdf`);
          resolve("downloaded-image-pdf");
        } else {
          reject(new Error("Invalid option: use 'pdf', 'images', or 'image-pdf'"));
        }
      } catch (err) {
        reject(err);
      }
    });
  });
};


/**
 * @function openStudentInfoPdfView
 * @description Opens a PDF view in a new tab for the given student data.
 * @param {Object} stData - Student data object
 * @param {Object} routeList - Route List data array
 * @returns {void}
 */


export const generateStudentDetailPDF = async (data, routeList) => {
  const user = data?.userInfo || {};
  const photoBase64 = data?.document?.stPhoto ? await urlToBase64(data.document.stPhoto) : null

  // Helper for input-like boxes
  const inputBox = (label, value, width = "100%") => ({
    stack: [
      { text: label, fontSize: 8, color: "#333", margin: [0, 0, 0, 2] },
      {
        table: {
          widths: [width],
          body: [[{ text: value || "", fontSize: 8, margin: [4, 3] }]],
        },
        layout: {
          hLineWidth: () => 1,
          vLineWidth: () => 1,
          hLineColor: () => "#ccc",
          vLineColor: () => "#ccc",
        },
      },
    ],
    margin: [0, 2, 0, 2],
  });

  const docDefinition = {
    pageSize: "A4",
    pageMargins: [40, 40, 40, 40],
    background: function (page) {
      return [
        {
          image: 'logo',
          width: 40,
          height: 40,
          absolutePosition: { x: 80, y: 40 }
        },
        { text: 'Estd. 2016', style: 'logoEstdAndTrust', absolutePosition: { x: 81, y: 80 }, font: 'Roboto', fontSize: 8 },
        { text: 'B.M. Memorial Trust: 5815/204', style: 'logoEstdAndTrust', absolutePosition: { x: 50, y: 90 }, fontSize: 8 },

      ];
    },
    content: [
      // HEADER
      {
        text: "B.M. MEMORIAL SCHOOL",
        style: "header",
        alignment: "center",
      },
      {
        text: "STUDENT DETAIL FORM",
        style: "title",
        alignment: "center",
        margin: [0, 5, 0, 20],
      },

      // ===== TOP SECTION (Admission details + Photo) =====
      {
        alignment: "left",
        table: {
          widths: ["65%", "5%", "30%"], // left data 60%, gap 5%, photo 35%
          body: [
            [
              // LEFT DATA AREA
              {
                stack: [
                  // Admission Date and Session in same row
                  {
                    columns: [
                      { width: "50%", stack: [inputBox("Admission Date", formatDateddmmyyyy(user.admissionDate))] },
                      { width: "50%", stack: [inputBox("Session", user.session)] },

                    ],
                    columnGap: 10,
                  },
                  //inputBox("Payment Ledger P.No", user.paymentLedgerPage),
                  inputBox("Full Name", user.fullName),

                  {
                    columns: [
                      { width: "50%", stack: [inputBox("BMMS ID", user.userId)] },
                      { width: "50%", stack: [inputBox("Date of Birth", formatDateddmmyyyy(user.dob))] },
                    ],
                    columnGap: 10,
                  },
                  {
                    columns: [
                      { width: "33%", stack: [inputBox("Class", user.class)] },
                      { width: "33%", stack: [inputBox("Gender", user.gender)] },
                      { width: "33%", stack: [inputBox("Blood Group", user.bloodGroup || ' ')] },
                    ],
                    columnGap: 10,
                  },

                  //inputBox("Class", user.class),
                  // inputBox(
                  //   "Bus Service / Fee Free",
                  //   `${user.busService ? "Yes" : "No"} / ${user.feeFree ? "Yes" : "No"}`
                  // ),
                ],
              },

              // MIDDLE GAP
              { text: "", border: [false, false, false, false] },

              // RIGHT PHOTO AREA
              {
                stack: [
                  {
                    table: {
                      widths: [100],
                      body: [
                        [
                          photoBase64
                            ? {
                              image: photoBase64,
                              width: 100,
                              height: 120,
                              alignment: "center",
                              margin: [2, 2, 2, 2],
                            }
                            : {
                              text: "Student Photo",
                              alignment: "center",
                              italics: true,
                              fontSize: 9,
                              margin: [0, 55, 0, 55],
                            },
                        ],
                      ],
                    },
                    layout: {
                      hLineWidth: () => 1,
                      vLineWidth: () => 1,
                      hLineColor: () => "#000",
                      vLineColor: () => "#000",
                    },
                    margin: [0, 0, 0, 5],
                    alignment: "center",
                  },
                  {
                    text: "Student Photo",
                    fontSize: 9,
                    alignment: "center",
                    margin: [0, 2, 0, 0],
                  },
                ],
              },
            ],
          ],
        },
        layout: "noBorders",
        margin: [0, 0, 0, 20],
      },

      // ===== TWO-COLUMN STUDENT INFO =====
      {
        columns: [
          {
            width: "50%",
            stack: [
              inputBox("Father Name", user.fatherName || ' '),
              inputBox("Primary Phone Number", user.phoneNumber1 || ' '),
              inputBox("Primary Address", user.address || ' '),
              inputBox("Height (cm)", user.height ? `${user.height} cm` : ' '),
              inputBox("Father Qualification", user.qualificationFather || ' '),
              inputBox("Bus Route", user.busService ? getBusRouteName(user.busRouteId, routeList) : 'N/A'),
              inputBox("Aadhar Number (12 Digit)", user.aadharNumber  || ' '),
              inputBox("APAAR ID (12 Digit)", user.apaarId || ' '),
            ],
          },
          {
            width: "50%",
            stack: [
              inputBox("Mother Name", user.motherName || ' '),
              inputBox("Secondary Phone Number", user.phoneNumber2 || ' '),
              inputBox("Secondary Address", user.address2 || ' '),
              inputBox("Weight (Kg)", user.weight ? `${user.weight} Kg` : ' '),
              inputBox("Mother Qualification", user.qualificationMother || ' '),
              inputBox("BPL / AAY / PH", user.isBelowPoverty === true ? 'Yes' : 'No'),
              inputBox("Category", user.category || ' '),
              inputBox("PEN Number", user.penNumber || ' '),
            ],
          },
        ],
        columnGap: 20,
      },

      // ===== SIGNATURE AREA (INLINE + LIGHT COLOR) =====
      {
        margin: [0, 80, 0, 0],
        table: {
          widths: ["50%", "50%"],
          body: [
            [
              {
                stack: [
                  // {
                  //   canvas: [
                  //     {
                  //       type: "line",
                  //       x1: 0,
                  //       y1: 0,
                  //       x2: 220,
                  //       y2: 0,
                  //       lineWidth: 0.7,
                  //       lineColor: "#999",
                  //     },
                  //   ],
                  //   margin: [0, 0, 0, 0],
                  // },
                  { text: "_________________________________________", fontSize: 5, color: "#555", alignment: "center" },
                  { text: "Guardian Signature", fontSize: 8, color: "#555", alignment: "center" },
                ],
              },
              {
                stack: [
                  // {
                  //   canvas: [
                  //     {
                  //       type: "line",
                  //       x1: 0,
                  //       y1: 0,
                  //       x2: 220,
                  //       y2: 0,
                  //       lineWidth: 0.7,
                  //       lineColor: "#999",
                  //     },
                  //   ],
                  //   margin: [0, 0, 0, 0],
                  // },
                  { text: "_________________________________________", fontSize: 5, color: "#555", alignment: "center" },
                  { text: "Principal Signature", fontSize: 8, color: "#555", alignment: "center" },
                ],
              },
            ],
          ],
        },
        layout: "noBorders",
      },
    ],
    images: {
      logo: schoolLogo
    },
    styles: {
      header: { fontSize: 18, bold: true },
      title: { fontSize: 13, bold: true, decoration: "underline" },
    },
  };
  const safeName = (str) =>
    (str || "Student").replace(/[^a-zA-Z0-9]/g, "_").trim();
  const pdfFileName = `${safeName(user.fullName)}_${safeName(user.class)}.pdf`;

  pdfMake.createPdf(docDefinition).download(pdfFileName);

  pdfMake.createPdf(docDefinition).open(); // or .download("StudentDetail_A4.pdf")
};





export var schoolLogo = 'data:image/png;base64,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';
